/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AccountsReceivableRouteRouteImport } from './routes/accounts-receivable/route';
import { Route as AuditTrailRouteImport } from './routes/audit-trail';
import { Route as BomsRouteRouteImport } from './routes/boms/route';
import { Route as BrandsRouteRouteImport } from './routes/brands/route';
import { Route as CompanySettingsRouteRouteImport } from './routes/company-settings/route';
import { Route as CompanySetupRouteRouteImport } from './routes/company-setup/route';
import { Route as CreditsRouteRouteImport } from './routes/credits/route';
import { Route as CustomersRouteRouteImport } from './routes/customers/route';
import { Route as DepartmentsRouteRouteImport } from './routes/departments/route';
import { Route as DesignSystemRouteRouteImport } from './routes/design-system/route';
import { Route as InventoryRouteRouteImport } from './routes/inventory/route';
import { Route as InvoicesRouteRouteImport } from './routes/invoices/route';
import { Route as LocationGroupsRouteRouteImport } from './routes/location-groups/route';
import { Route as LocationsRouteRouteImport } from './routes/locations/route';
import { Route as LoginRouteImport } from './routes/login';
import { Route as ManufacturingRouteImport } from './routes/manufacturing';
import { Route as PartsRouteRouteImport } from './routes/parts/route';
import { Route as PickingRouteRouteImport } from './routes/picking/route';
import { Route as PricingRouteRouteImport } from './routes/pricing/route';
import { Route as PricingRulesRouteRouteImport } from './routes/pricing-rules/route';
import { Route as ProductCategoriesRouteRouteImport } from './routes/product-categories/route';
import { Route as ProductsRouteRouteImport } from './routes/products/route';
import { Route as PurchaseOrdersRouteImport } from './routes/purchase-orders';
import { Route as ReceivingRouteImport } from './routes/receiving';
import { Route as RolesRouteRouteImport } from './routes/roles/route';
import { Route as SalesOrdersRouteRouteImport } from './routes/sales-orders/route';
import { Route as SupplierReturnsRouteImport } from './routes/supplier-returns';
import { Route as TransferOrdersRouteRouteImport } from './routes/transfer-orders/route';
import { Route as UsersRouteRouteImport } from './routes/users/route';
import { Route as VendorsRouteRouteImport } from './routes/vendors/route';
import { Route as WarehousesRouteRouteImport } from './routes/warehouses/route';
import { Route as AccountsReceivableIndexRouteImport } from './routes/accounts-receivable/index';
import { Route as AuditTrailIndexRouteImport } from './routes/audit-trail/index';
import { Route as BomsIndexRouteImport } from './routes/boms/index';
import { Route as BomsBomIdRouteImport } from './routes/boms/$bomId';
import { Route as BomsNewRouteImport } from './routes/boms/new';
import { Route as BrandsIndexRouteImport } from './routes/brands/index';
import { Route as BrandsBrandIdRouteImport } from './routes/brands/$brandId';
import { Route as BrandsNewRouteImport } from './routes/brands/new';
import { Route as CompanySettingsIndexRouteImport } from './routes/company-settings/index';
import { Route as CompanySetupIndexRouteImport } from './routes/company-setup/index';
import { Route as CreditsIndexRouteImport } from './routes/credits/index';
import { Route as CreditsCreditIdRouteImport } from './routes/credits/$creditId';
import { Route as CustomReportsIndexRouteImport } from './routes/custom-reports/index';
import { Route as CustomersIndexRouteImport } from './routes/customers/index';
import { Route as CustomersCustomerIdRouteImport } from './routes/customers/$customerId';
import { Route as CustomersNewRouteImport } from './routes/customers/new';
import { Route as DepartmentsIndexRouteImport } from './routes/departments/index';
import { Route as DepartmentsDepartmentIdRouteImport } from './routes/departments/$departmentId';
import { Route as DepartmentsNewRouteImport } from './routes/departments/new';
import { Route as DesignSystemIndexRouteImport } from './routes/design-system/index';
import { Route as DesignSystemAccordionRouteImport } from './routes/design-system/accordion';
import { Route as DesignSystemAlertRouteImport } from './routes/design-system/alert';
import { Route as DesignSystemAspectRatioRouteImport } from './routes/design-system/aspect-ratio';
import { Route as DesignSystemAttachmentRouteImport } from './routes/design-system/attachment';
import { Route as DesignSystemAvatarRouteImport } from './routes/design-system/avatar';
import { Route as DesignSystemBreadcrumbRouteImport } from './routes/design-system/breadcrumb';
import { Route as DesignSystemButtonRouteImport } from './routes/design-system/button';
import { Route as DesignSystemButtonGroupRouteImport } from './routes/design-system/button-group';
import { Route as DesignSystemCalendarRouteImport } from './routes/design-system/calendar';
import { Route as DesignSystemCardRouteImport } from './routes/design-system/card';
import { Route as DesignSystemCardShellRouteImport } from './routes/design-system/card-shell';
import { Route as DesignSystemCheckboxRouteImport } from './routes/design-system/checkbox';
import { Route as DesignSystemChipRouteImport } from './routes/design-system/chip';
import { Route as DesignSystemCollapsibleRouteImport } from './routes/design-system/collapsible';
import { Route as DesignSystemComboboxRouteImport } from './routes/design-system/combobox';
import { Route as DesignSystemDataTableRouteImport } from './routes/design-system/data-table';
import { Route as DesignSystemDatePickerRouteImport } from './routes/design-system/date-picker';
import { Route as DesignSystemDetailCardShellRouteImport } from './routes/design-system/detail-card-shell';
import { Route as DesignSystemDetailPageStatesRouteImport } from './routes/design-system/detail-page-states';
import { Route as DesignSystemDialogRouteImport } from './routes/design-system/dialog';
import { Route as DesignSystemDropdownMenuRouteImport } from './routes/design-system/dropdown-menu';
import { Route as DesignSystemEditableCellRouteImport } from './routes/design-system/editable-cell';
import { Route as DesignSystemEmptyRouteImport } from './routes/design-system/empty';
import { Route as DesignSystemFieldRouteImport } from './routes/design-system/field';
import { Route as DesignSystemFilterButtonRouteImport } from './routes/design-system/filter-button';
import { Route as DesignSystemInputRouteImport } from './routes/design-system/input';
import { Route as DesignSystemInputGroupRouteImport } from './routes/design-system/input-group';
import { Route as DesignSystemItemRouteImport } from './routes/design-system/item';
import { Route as DesignSystemLabelRouteImport } from './routes/design-system/label';
import { Route as DesignSystemMenubarRouteImport } from './routes/design-system/menubar';
import { Route as DesignSystemNestedTableRouteImport } from './routes/design-system/nested-table';
import { Route as DesignSystemRadioGroupRouteImport } from './routes/design-system/radio-group';
import { Route as DesignSystemResizableRouteImport } from './routes/design-system/resizable';
import { Route as DesignSystemScrollAreaRouteImport } from './routes/design-system/scroll-area';
import { Route as DesignSystemSelectRouteImport } from './routes/design-system/select';
import { Route as DesignSystemSeparatorRouteImport } from './routes/design-system/separator';
import { Route as DesignSystemSheetRouteImport } from './routes/design-system/sheet';
import { Route as DesignSystemSidebarRouteImport } from './routes/design-system/sidebar';
import { Route as DesignSystemSonnerRouteImport } from './routes/design-system/sonner';
import { Route as DesignSystemSpinnerRouteImport } from './routes/design-system/spinner';
import { Route as DesignSystemSwitchRouteImport } from './routes/design-system/switch';
import { Route as DesignSystemTableRouteImport } from './routes/design-system/table';
import { Route as DesignSystemTabsRouteImport } from './routes/design-system/tabs';
import { Route as DesignSystemTextareaRouteImport } from './routes/design-system/textarea';
import { Route as DesignSystemToggleRouteImport } from './routes/design-system/toggle';
import { Route as DesignSystemToggleGroupRouteImport } from './routes/design-system/toggle-group';
import { Route as DesignSystemTooltipRouteImport } from './routes/design-system/tooltip';
import { Route as DesignSystemTreeComboboxRouteImport } from './routes/design-system/tree-combobox';
import { Route as DesignSystemTreeTableRouteImport } from './routes/design-system/tree-table';
import { Route as DesignSystemWizardRouteImport } from './routes/design-system/wizard';
import { Route as EventsIndexRouteImport } from './routes/events/index';
import { Route as EventsEventIdRouteImport } from './routes/events/$eventId';
import { Route as EventsAwaitingApprovalRouteImport } from './routes/events/awaiting-approval';
import { Route as EventsAwaitingReviewRouteImport } from './routes/events/awaiting-review';
import { Route as EventsContactsRouteImport } from './routes/events/contacts';
import { Route as EventsNewRouteImport } from './routes/events/new';
import { Route as EventsTagsRouteImport } from './routes/events/tags';
import { Route as IntegrationsLeaflinkRouteRouteImport } from './routes/integrations/leaflink/route';
import { Route as IntegrationsSageIntacctRouteRouteImport } from './routes/integrations/sage-intacct/route';
import { Route as InventoryIndexRouteImport } from './routes/inventory/index';
import { Route as InventoryLotHistoryRouteImport } from './routes/inventory/lot-history';
import { Route as InventoryTagsRouteImport } from './routes/inventory/tags';
import { Route as InvoicesIndexRouteImport } from './routes/invoices/index';
import { Route as InvoicesInvoiceIdRouteImport } from './routes/invoices/$invoiceId';
import { Route as LeaflinkCompaniesSplatRouteImport } from './routes/leaflink-companies/$';
import { Route as LocationGroupsIndexRouteImport } from './routes/location-groups/index';
import { Route as LocationGroupsLocationGroupIdRouteImport } from './routes/location-groups/$locationGroupId';
import { Route as LocationGroupsNewRouteImport } from './routes/location-groups/new';
import { Route as LocationsIndexRouteImport } from './routes/locations/index';
import { Route as LocationsLocationIdRouteImport } from './routes/locations/$locationId';
import { Route as LocationsNewRouteImport } from './routes/locations/new';
import { Route as ManufacturingIndexRouteImport } from './routes/manufacturing/index';
import { Route as ManufacturingManufacturingOrderIdRouteImport } from './routes/manufacturing/$manufacturingOrderId';
import { Route as ManufacturingNewRouteImport } from './routes/manufacturing/new';
import { Route as OauthConsentRouteImport } from './routes/oauth/consent';
import { Route as PartsIndexRouteImport } from './routes/parts/index';
import { Route as PartsPartIdRouteImport } from './routes/parts/$partId';
import { Route as PartsNewRouteRouteImport } from './routes/parts/new/route';
import { Route as PickingIndexRouteImport } from './routes/picking/index';
import { Route as PricingRulesIndexRouteImport } from './routes/pricing-rules/index';
import { Route as PricingRulesPriceRuleIdRouteImport } from './routes/pricing-rules/$priceRuleId';
import { Route as PricingIndexRouteImport } from './routes/pricing/index';
import { Route as ProductCategoriesIndexRouteImport } from './routes/product-categories/index';
import { Route as ProductCategoriesProductTreeIdRouteImport } from './routes/product-categories/$productTreeId';
import { Route as ProductsIndexRouteImport } from './routes/products/index';
import { Route as ProductsProductIdRouteImport } from './routes/products/$productId';
import { Route as ProductsNewRouteImport } from './routes/products/new';
import { Route as PurchaseOrdersIndexRouteImport } from './routes/purchase-orders/index';
import { Route as PurchaseOrdersPurchaseOrderIdRouteImport } from './routes/purchase-orders/$purchaseOrderId';
import { Route as PurchaseOrdersNewRouteImport } from './routes/purchase-orders/new';
import { Route as ReceivingIndexRouteImport } from './routes/receiving/index';
import { Route as ReceivingPurchaseOrderIdRouteImport } from './routes/receiving/$purchaseOrderId';
import { Route as RolesIndexRouteImport } from './routes/roles/index';
import { Route as RolesRoleIdRouteImport } from './routes/roles/$roleId';
import { Route as RolesNewRouteImport } from './routes/roles/new';
import { Route as SalesOrdersIndexRouteImport } from './routes/sales-orders/index';
import { Route as SalesOrdersSalesOrderIdRouteImport } from './routes/sales-orders/$salesOrderId';
import { Route as SalesOrdersNewRouteImport } from './routes/sales-orders/new';
import { Route as SupplierReturnsIndexRouteImport } from './routes/supplier-returns/index';
import { Route as TransferOrdersIndexRouteImport } from './routes/transfer-orders/index';
import { Route as TransferOrdersTransferOrderIdRouteImport } from './routes/transfer-orders/$transferOrderId';
import { Route as TransferOrdersNewRouteImport } from './routes/transfer-orders/new';
import { Route as UsersIndexRouteImport } from './routes/users/index';
import { Route as UsersUserIdRouteImport } from './routes/users/$userId';
import { Route as VendorsIndexRouteImport } from './routes/vendors/index';
import { Route as VendorsVendorIdRouteImport } from './routes/vendors/$vendorId';
import { Route as VendorsNewRouteImport } from './routes/vendors/new';
import { Route as WarehousesIndexRouteImport } from './routes/warehouses/index';
import { Route as WarehousesLocationGroupIdRouteRouteImport } from './routes/warehouses/$locationGroupId/route';
import { Route as WarehousesNewRouteImport } from './routes/warehouses/new';
import { Route as EventsTemplatesIndexRouteImport } from './routes/events/templates/index';
import { Route as EventsTemplatesTemplateVersionIdRouteImport } from './routes/events/templates/$templateVersionId';
import { Route as EventsTemplatesNewRouteImport } from './routes/events/templates/new';
import { Route as IntegrationsLeaflinkIndexRouteImport } from './routes/integrations/leaflink/index';
import { Route as IntegrationsSageIntacctIndexRouteImport } from './routes/integrations/sage-intacct/index';
import { Route as InventoryCountsNewRouteImport } from './routes/inventory/counts/new';
import { Route as ManufacturingWorkOrdersIndexRouteImport } from './routes/manufacturing/work-orders/index';
import { Route as ManufacturingWorkOrdersWorkOrderIdRouteImport } from './routes/manufacturing/work-orders/$workOrderId';
import { Route as PartsNewIndexRouteImport } from './routes/parts/new/index';
import { Route as ReceivingReturnsSalesOrderIdRouteImport } from './routes/receiving/returns/$salesOrderId';
import { Route as ReceivingTransferTransferOrderIdRouteImport } from './routes/receiving/transfer/$transferOrderId';
import { Route as WarehousesLocationGroupIdIndexRouteImport } from './routes/warehouses/$locationGroupId/index';
import { Route as WarehousesLocationGroupIdLocationIdRouteImport } from './routes/warehouses/$locationGroupId/$locationId';
import { Route as WarehousesLocationGroupIdNewRouteImport } from './routes/warehouses/$locationGroupId/new';
import { Route as IntegrationsLeaflinkLeafLinkIntegrationIdIndexRouteImport } from './routes/integrations/leaflink/$leafLinkIntegrationId/index';
import { Route as IntegrationsLeaflinkLeafLinkIntegrationIdCustomersRouteImport } from './routes/integrations/leaflink/$leafLinkIntegrationId/customers';
import { Route as IntegrationsLeaflinkLeafLinkIntegrationIdHeldOrdersRouteImport } from './routes/integrations/leaflink/$leafLinkIntegrationId/held-orders';
import { Route as IntegrationsLeaflinkLeafLinkIntegrationIdListProductsRouteImport } from './routes/integrations/leaflink/$leafLinkIntegrationId/list-products';
import { Route as IntegrationsLeaflinkLeafLinkIntegrationIdOrdersRouteImport } from './routes/integrations/leaflink/$leafLinkIntegrationId/orders';
import { Route as IntegrationsLeaflinkLeafLinkIntegrationIdProductsRouteImport } from './routes/integrations/leaflink/$leafLinkIntegrationId/products';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AccountsReceivableRouteRoute = AccountsReceivableRouteRouteImport.update({
  id: '/accounts-receivable',
  path: '/accounts-receivable',
  getParentRoute: () => rootRouteImport,
} as any);
const AuditTrailRoute = AuditTrailRouteImport.update({
  id: '/audit-trail',
  path: '/audit-trail',
  getParentRoute: () => rootRouteImport,
} as any);
const BomsRouteRoute = BomsRouteRouteImport.update({
  id: '/boms',
  path: '/boms',
  getParentRoute: () => rootRouteImport,
} as any);
const BrandsRouteRoute = BrandsRouteRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => rootRouteImport,
} as any);
const CompanySettingsRouteRoute = CompanySettingsRouteRouteImport.update({
  id: '/company-settings',
  path: '/company-settings',
  getParentRoute: () => rootRouteImport,
} as any);
const CompanySetupRouteRoute = CompanySetupRouteRouteImport.update({
  id: '/company-setup',
  path: '/company-setup',
  getParentRoute: () => rootRouteImport,
} as any);
const CreditsRouteRoute = CreditsRouteRouteImport.update({
  id: '/credits',
  path: '/credits',
  getParentRoute: () => rootRouteImport,
} as any);
const CustomersRouteRoute = CustomersRouteRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRouteImport,
} as any);
const DepartmentsRouteRoute = DepartmentsRouteRouteImport.update({
  id: '/departments',
  path: '/departments',
  getParentRoute: () => rootRouteImport,
} as any);
const DesignSystemRouteRoute = DesignSystemRouteRouteImport.update({
  id: '/design-system',
  path: '/design-system',
  getParentRoute: () => rootRouteImport,
} as any);
const InventoryRouteRoute = InventoryRouteRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRouteImport,
} as any);
const InvoicesRouteRoute = InvoicesRouteRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => rootRouteImport,
} as any);
const LocationGroupsRouteRoute = LocationGroupsRouteRouteImport.update({
  id: '/location-groups',
  path: '/location-groups',
  getParentRoute: () => rootRouteImport,
} as any);
const LocationsRouteRoute = LocationsRouteRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const ManufacturingRoute = ManufacturingRouteImport.update({
  id: '/manufacturing',
  path: '/manufacturing',
  getParentRoute: () => rootRouteImport,
} as any);
const PartsRouteRoute = PartsRouteRouteImport.update({
  id: '/parts',
  path: '/parts',
  getParentRoute: () => rootRouteImport,
} as any);
const PickingRouteRoute = PickingRouteRouteImport.update({
  id: '/picking',
  path: '/picking',
  getParentRoute: () => rootRouteImport,
} as any);
const PricingRouteRoute = PricingRouteRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any);
const PricingRulesRouteRoute = PricingRulesRouteRouteImport.update({
  id: '/pricing-rules',
  path: '/pricing-rules',
  getParentRoute: () => rootRouteImport,
} as any);
const ProductCategoriesRouteRoute = ProductCategoriesRouteRouteImport.update({
  id: '/product-categories',
  path: '/product-categories',
  getParentRoute: () => rootRouteImport,
} as any);
const ProductsRouteRoute = ProductsRouteRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any);
const PurchaseOrdersRoute = PurchaseOrdersRouteImport.update({
  id: '/purchase-orders',
  path: '/purchase-orders',
  getParentRoute: () => rootRouteImport,
} as any);
const ReceivingRoute = ReceivingRouteImport.update({
  id: '/receiving',
  path: '/receiving',
  getParentRoute: () => rootRouteImport,
} as any);
const RolesRouteRoute = RolesRouteRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => rootRouteImport,
} as any);
const SalesOrdersRouteRoute = SalesOrdersRouteRouteImport.update({
  id: '/sales-orders',
  path: '/sales-orders',
  getParentRoute: () => rootRouteImport,
} as any);
const SupplierReturnsRoute = SupplierReturnsRouteImport.update({
  id: '/supplier-returns',
  path: '/supplier-returns',
  getParentRoute: () => rootRouteImport,
} as any);
const TransferOrdersRouteRoute = TransferOrdersRouteRouteImport.update({
  id: '/transfer-orders',
  path: '/transfer-orders',
  getParentRoute: () => rootRouteImport,
} as any);
const UsersRouteRoute = UsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any);
const VendorsRouteRoute = VendorsRouteRouteImport.update({
  id: '/vendors',
  path: '/vendors',
  getParentRoute: () => rootRouteImport,
} as any);
const WarehousesRouteRoute = WarehousesRouteRouteImport.update({
  id: '/warehouses',
  path: '/warehouses',
  getParentRoute: () => rootRouteImport,
} as any);
const AccountsReceivableIndexRoute = AccountsReceivableIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountsReceivableRouteRoute,
} as any);
const AuditTrailIndexRoute = AuditTrailIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuditTrailRoute,
} as any);
const BomsIndexRoute = BomsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BomsRouteRoute,
} as any);
const BomsBomIdRoute = BomsBomIdRouteImport.update({
  id: '/$bomId',
  path: '/$bomId',
  getParentRoute: () => BomsRouteRoute,
} as any);
const BomsNewRoute = BomsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => BomsRouteRoute,
} as any);
const BrandsIndexRoute = BrandsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BrandsRouteRoute,
} as any);
const BrandsBrandIdRoute = BrandsBrandIdRouteImport.update({
  id: '/$brandId',
  path: '/$brandId',
  getParentRoute: () => BrandsRouteRoute,
} as any);
const BrandsNewRoute = BrandsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => BrandsRouteRoute,
} as any);
const CompanySettingsIndexRoute = CompanySettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CompanySettingsRouteRoute,
} as any);
const CompanySetupIndexRoute = CompanySetupIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CompanySetupRouteRoute,
} as any);
const CreditsIndexRoute = CreditsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CreditsRouteRoute,
} as any);
const CreditsCreditIdRoute = CreditsCreditIdRouteImport.update({
  id: '/$creditId',
  path: '/$creditId',
  getParentRoute: () => CreditsRouteRoute,
} as any);
const CustomReportsIndexRoute = CustomReportsIndexRouteImport.update({
  id: '/custom-reports/',
  path: '/custom-reports/',
  getParentRoute: () => rootRouteImport,
} as any);
const CustomersIndexRoute = CustomersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CustomersRouteRoute,
} as any);
const CustomersCustomerIdRoute = CustomersCustomerIdRouteImport.update({
  id: '/$customerId',
  path: '/$customerId',
  getParentRoute: () => CustomersRouteRoute,
} as any);
const CustomersNewRoute = CustomersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => CustomersRouteRoute,
} as any);
const DepartmentsIndexRoute = DepartmentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DepartmentsRouteRoute,
} as any);
const DepartmentsDepartmentIdRoute = DepartmentsDepartmentIdRouteImport.update({
  id: '/$departmentId',
  path: '/$departmentId',
  getParentRoute: () => DepartmentsRouteRoute,
} as any);
const DepartmentsNewRoute = DepartmentsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => DepartmentsRouteRoute,
} as any);
const DesignSystemIndexRoute = DesignSystemIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemAccordionRoute = DesignSystemAccordionRouteImport.update({
  id: '/accordion',
  path: '/accordion',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemAlertRoute = DesignSystemAlertRouteImport.update({
  id: '/alert',
  path: '/alert',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemAspectRatioRoute = DesignSystemAspectRatioRouteImport.update({
  id: '/aspect-ratio',
  path: '/aspect-ratio',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemAttachmentRoute = DesignSystemAttachmentRouteImport.update({
  id: '/attachment',
  path: '/attachment',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemAvatarRoute = DesignSystemAvatarRouteImport.update({
  id: '/avatar',
  path: '/avatar',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemBreadcrumbRoute = DesignSystemBreadcrumbRouteImport.update({
  id: '/breadcrumb',
  path: '/breadcrumb',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemButtonRoute = DesignSystemButtonRouteImport.update({
  id: '/button',
  path: '/button',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemButtonGroupRoute = DesignSystemButtonGroupRouteImport.update({
  id: '/button-group',
  path: '/button-group',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemCalendarRoute = DesignSystemCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemCardRoute = DesignSystemCardRouteImport.update({
  id: '/card',
  path: '/card',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemCardShellRoute = DesignSystemCardShellRouteImport.update({
  id: '/card-shell',
  path: '/card-shell',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemCheckboxRoute = DesignSystemCheckboxRouteImport.update({
  id: '/checkbox',
  path: '/checkbox',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemChipRoute = DesignSystemChipRouteImport.update({
  id: '/chip',
  path: '/chip',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemCollapsibleRoute = DesignSystemCollapsibleRouteImport.update({
  id: '/collapsible',
  path: '/collapsible',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemComboboxRoute = DesignSystemComboboxRouteImport.update({
  id: '/combobox',
  path: '/combobox',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemDataTableRoute = DesignSystemDataTableRouteImport.update({
  id: '/data-table',
  path: '/data-table',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemDatePickerRoute = DesignSystemDatePickerRouteImport.update({
  id: '/date-picker',
  path: '/date-picker',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemDetailCardShellRoute =
  DesignSystemDetailCardShellRouteImport.update({
    id: '/detail-card-shell',
    path: '/detail-card-shell',
    getParentRoute: () => DesignSystemRouteRoute,
  } as any);
const DesignSystemDetailPageStatesRoute =
  DesignSystemDetailPageStatesRouteImport.update({
    id: '/detail-page-states',
    path: '/detail-page-states',
    getParentRoute: () => DesignSystemRouteRoute,
  } as any);
const DesignSystemDialogRoute = DesignSystemDialogRouteImport.update({
  id: '/dialog',
  path: '/dialog',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemDropdownMenuRoute =
  DesignSystemDropdownMenuRouteImport.update({
    id: '/dropdown-menu',
    path: '/dropdown-menu',
    getParentRoute: () => DesignSystemRouteRoute,
  } as any);
const DesignSystemEditableCellRoute =
  DesignSystemEditableCellRouteImport.update({
    id: '/editable-cell',
    path: '/editable-cell',
    getParentRoute: () => DesignSystemRouteRoute,
  } as any);
const DesignSystemEmptyRoute = DesignSystemEmptyRouteImport.update({
  id: '/empty',
  path: '/empty',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemFieldRoute = DesignSystemFieldRouteImport.update({
  id: '/field',
  path: '/field',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemFilterButtonRoute =
  DesignSystemFilterButtonRouteImport.update({
    id: '/filter-button',
    path: '/filter-button',
    getParentRoute: () => DesignSystemRouteRoute,
  } as any);
const DesignSystemInputRoute = DesignSystemInputRouteImport.update({
  id: '/input',
  path: '/input',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemInputGroupRoute = DesignSystemInputGroupRouteImport.update({
  id: '/input-group',
  path: '/input-group',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemItemRoute = DesignSystemItemRouteImport.update({
  id: '/item',
  path: '/item',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemLabelRoute = DesignSystemLabelRouteImport.update({
  id: '/label',
  path: '/label',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemMenubarRoute = DesignSystemMenubarRouteImport.update({
  id: '/menubar',
  path: '/menubar',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemNestedTableRoute = DesignSystemNestedTableRouteImport.update({
  id: '/nested-table',
  path: '/nested-table',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemRadioGroupRoute = DesignSystemRadioGroupRouteImport.update({
  id: '/radio-group',
  path: '/radio-group',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemResizableRoute = DesignSystemResizableRouteImport.update({
  id: '/resizable',
  path: '/resizable',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemScrollAreaRoute = DesignSystemScrollAreaRouteImport.update({
  id: '/scroll-area',
  path: '/scroll-area',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemSelectRoute = DesignSystemSelectRouteImport.update({
  id: '/select',
  path: '/select',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemSeparatorRoute = DesignSystemSeparatorRouteImport.update({
  id: '/separator',
  path: '/separator',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemSheetRoute = DesignSystemSheetRouteImport.update({
  id: '/sheet',
  path: '/sheet',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemSidebarRoute = DesignSystemSidebarRouteImport.update({
  id: '/sidebar',
  path: '/sidebar',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemSonnerRoute = DesignSystemSonnerRouteImport.update({
  id: '/sonner',
  path: '/sonner',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemSpinnerRoute = DesignSystemSpinnerRouteImport.update({
  id: '/spinner',
  path: '/spinner',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemSwitchRoute = DesignSystemSwitchRouteImport.update({
  id: '/switch',
  path: '/switch',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemTableRoute = DesignSystemTableRouteImport.update({
  id: '/table',
  path: '/table',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemTabsRoute = DesignSystemTabsRouteImport.update({
  id: '/tabs',
  path: '/tabs',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemTextareaRoute = DesignSystemTextareaRouteImport.update({
  id: '/textarea',
  path: '/textarea',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemToggleRoute = DesignSystemToggleRouteImport.update({
  id: '/toggle',
  path: '/toggle',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemToggleGroupRoute = DesignSystemToggleGroupRouteImport.update({
  id: '/toggle-group',
  path: '/toggle-group',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemTooltipRoute = DesignSystemTooltipRouteImport.update({
  id: '/tooltip',
  path: '/tooltip',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemTreeComboboxRoute =
  DesignSystemTreeComboboxRouteImport.update({
    id: '/tree-combobox',
    path: '/tree-combobox',
    getParentRoute: () => DesignSystemRouteRoute,
  } as any);
const DesignSystemTreeTableRoute = DesignSystemTreeTableRouteImport.update({
  id: '/tree-table',
  path: '/tree-table',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const DesignSystemWizardRoute = DesignSystemWizardRouteImport.update({
  id: '/wizard',
  path: '/wizard',
  getParentRoute: () => DesignSystemRouteRoute,
} as any);
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => rootRouteImport,
} as any);
const EventsEventIdRoute = EventsEventIdRouteImport.update({
  id: '/events/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => rootRouteImport,
} as any);
const EventsAwaitingApprovalRoute = EventsAwaitingApprovalRouteImport.update({
  id: '/events/awaiting-approval',
  path: '/events/awaiting-approval',
  getParentRoute: () => rootRouteImport,
} as any);
const EventsAwaitingReviewRoute = EventsAwaitingReviewRouteImport.update({
  id: '/events/awaiting-review',
  path: '/events/awaiting-review',
  getParentRoute: () => rootRouteImport,
} as any);
const EventsContactsRoute = EventsContactsRouteImport.update({
  id: '/events/contacts',
  path: '/events/contacts',
  getParentRoute: () => rootRouteImport,
} as any);
const EventsNewRoute = EventsNewRouteImport.update({
  id: '/events/new',
  path: '/events/new',
  getParentRoute: () => rootRouteImport,
} as any);
const EventsTagsRoute = EventsTagsRouteImport.update({
  id: '/events/tags',
  path: '/events/tags',
  getParentRoute: () => rootRouteImport,
} as any);
const IntegrationsLeaflinkRouteRoute =
  IntegrationsLeaflinkRouteRouteImport.update({
    id: '/integrations/leaflink',
    path: '/integrations/leaflink',
    getParentRoute: () => rootRouteImport,
  } as any);
const IntegrationsSageIntacctRouteRoute =
  IntegrationsSageIntacctRouteRouteImport.update({
    id: '/integrations/sage-intacct',
    path: '/integrations/sage-intacct',
    getParentRoute: () => rootRouteImport,
  } as any);
const InventoryIndexRoute = InventoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InventoryRouteRoute,
} as any);
const InventoryLotHistoryRoute = InventoryLotHistoryRouteImport.update({
  id: '/lot-history',
  path: '/lot-history',
  getParentRoute: () => InventoryRouteRoute,
} as any);
const InventoryTagsRoute = InventoryTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => InventoryRouteRoute,
} as any);
const InvoicesIndexRoute = InvoicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InvoicesRouteRoute,
} as any);
const InvoicesInvoiceIdRoute = InvoicesInvoiceIdRouteImport.update({
  id: '/$invoiceId',
  path: '/$invoiceId',
  getParentRoute: () => InvoicesRouteRoute,
} as any);
const LeaflinkCompaniesSplatRoute = LeaflinkCompaniesSplatRouteImport.update({
  id: '/leaflink-companies/$',
  path: '/leaflink-companies/$',
  getParentRoute: () => rootRouteImport,
} as any);
const LocationGroupsIndexRoute = LocationGroupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocationGroupsRouteRoute,
} as any);
const LocationGroupsLocationGroupIdRoute =
  LocationGroupsLocationGroupIdRouteImport.update({
    id: '/$locationGroupId',
    path: '/$locationGroupId',
    getParentRoute: () => LocationGroupsRouteRoute,
  } as any);
const LocationGroupsNewRoute = LocationGroupsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => LocationGroupsRouteRoute,
} as any);
const LocationsIndexRoute = LocationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocationsRouteRoute,
} as any);
const LocationsLocationIdRoute = LocationsLocationIdRouteImport.update({
  id: '/$locationId',
  path: '/$locationId',
  getParentRoute: () => LocationsRouteRoute,
} as any);
const LocationsNewRoute = LocationsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => LocationsRouteRoute,
} as any);
const ManufacturingIndexRoute = ManufacturingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ManufacturingRoute,
} as any);
const ManufacturingManufacturingOrderIdRoute =
  ManufacturingManufacturingOrderIdRouteImport.update({
    id: '/$manufacturingOrderId',
    path: '/$manufacturingOrderId',
    getParentRoute: () => ManufacturingRoute,
  } as any);
const ManufacturingNewRoute = ManufacturingNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ManufacturingRoute,
} as any);
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any);
const PartsIndexRoute = PartsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PartsRouteRoute,
} as any);
const PartsPartIdRoute = PartsPartIdRouteImport.update({
  id: '/$partId',
  path: '/$partId',
  getParentRoute: () => PartsRouteRoute,
} as any);
const PartsNewRouteRoute = PartsNewRouteRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => PartsRouteRoute,
} as any);
const PickingIndexRoute = PickingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PickingRouteRoute,
} as any);
const PricingRulesIndexRoute = PricingRulesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PricingRulesRouteRoute,
} as any);
const PricingRulesPriceRuleIdRoute = PricingRulesPriceRuleIdRouteImport.update({
  id: '/$priceRuleId',
  path: '/$priceRuleId',
  getParentRoute: () => PricingRulesRouteRoute,
} as any);
const PricingIndexRoute = PricingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PricingRouteRoute,
} as any);
const ProductCategoriesIndexRoute = ProductCategoriesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductCategoriesRouteRoute,
} as any);
const ProductCategoriesProductTreeIdRoute =
  ProductCategoriesProductTreeIdRouteImport.update({
    id: '/$productTreeId',
    path: '/$productTreeId',
    getParentRoute: () => ProductCategoriesRouteRoute,
  } as any);
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductsRouteRoute,
} as any);
const ProductsProductIdRoute = ProductsProductIdRouteImport.update({
  id: '/$productId',
  path: '/$productId',
  getParentRoute: () => ProductsRouteRoute,
} as any);
const ProductsNewRoute = ProductsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ProductsRouteRoute,
} as any);
const PurchaseOrdersIndexRoute = PurchaseOrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PurchaseOrdersRoute,
} as any);
const PurchaseOrdersPurchaseOrderIdRoute =
  PurchaseOrdersPurchaseOrderIdRouteImport.update({
    id: '/$purchaseOrderId',
    path: '/$purchaseOrderId',
    getParentRoute: () => PurchaseOrdersRoute,
  } as any);
const PurchaseOrdersNewRoute = PurchaseOrdersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => PurchaseOrdersRoute,
} as any);
const ReceivingIndexRoute = ReceivingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ReceivingRoute,
} as any);
const ReceivingPurchaseOrderIdRoute =
  ReceivingPurchaseOrderIdRouteImport.update({
    id: '/$purchaseOrderId',
    path: '/$purchaseOrderId',
    getParentRoute: () => ReceivingRoute,
  } as any);
const RolesIndexRoute = RolesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RolesRouteRoute,
} as any);
const RolesRoleIdRoute = RolesRoleIdRouteImport.update({
  id: '/$roleId',
  path: '/$roleId',
  getParentRoute: () => RolesRouteRoute,
} as any);
const RolesNewRoute = RolesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => RolesRouteRoute,
} as any);
const SalesOrdersIndexRoute = SalesOrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SalesOrdersRouteRoute,
} as any);
const SalesOrdersSalesOrderIdRoute = SalesOrdersSalesOrderIdRouteImport.update({
  id: '/$salesOrderId',
  path: '/$salesOrderId',
  getParentRoute: () => SalesOrdersRouteRoute,
} as any);
const SalesOrdersNewRoute = SalesOrdersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SalesOrdersRouteRoute,
} as any);
const SupplierReturnsIndexRoute = SupplierReturnsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SupplierReturnsRoute,
} as any);
const TransferOrdersIndexRoute = TransferOrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TransferOrdersRouteRoute,
} as any);
const TransferOrdersTransferOrderIdRoute =
  TransferOrdersTransferOrderIdRouteImport.update({
    id: '/$transferOrderId',
    path: '/$transferOrderId',
    getParentRoute: () => TransferOrdersRouteRoute,
  } as any);
const TransferOrdersNewRoute = TransferOrdersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => TransferOrdersRouteRoute,
} as any);
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UsersRouteRoute,
} as any);
const UsersUserIdRoute = UsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => UsersRouteRoute,
} as any);
const VendorsIndexRoute = VendorsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VendorsRouteRoute,
} as any);
const VendorsVendorIdRoute = VendorsVendorIdRouteImport.update({
  id: '/$vendorId',
  path: '/$vendorId',
  getParentRoute: () => VendorsRouteRoute,
} as any);
const VendorsNewRoute = VendorsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => VendorsRouteRoute,
} as any);
const WarehousesIndexRoute = WarehousesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WarehousesRouteRoute,
} as any);
const WarehousesLocationGroupIdRouteRoute =
  WarehousesLocationGroupIdRouteRouteImport.update({
    id: '/$locationGroupId',
    path: '/$locationGroupId',
    getParentRoute: () => WarehousesRouteRoute,
  } as any);
const WarehousesNewRoute = WarehousesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => WarehousesRouteRoute,
} as any);
const EventsTemplatesIndexRoute = EventsTemplatesIndexRouteImport.update({
  id: '/events/templates/',
  path: '/events/templates/',
  getParentRoute: () => rootRouteImport,
} as any);
const EventsTemplatesTemplateVersionIdRoute =
  EventsTemplatesTemplateVersionIdRouteImport.update({
    id: '/events/templates/$templateVersionId',
    path: '/events/templates/$templateVersionId',
    getParentRoute: () => rootRouteImport,
  } as any);
const EventsTemplatesNewRoute = EventsTemplatesNewRouteImport.update({
  id: '/events/templates/new',
  path: '/events/templates/new',
  getParentRoute: () => rootRouteImport,
} as any);
const IntegrationsLeaflinkIndexRoute =
  IntegrationsLeaflinkIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => IntegrationsLeaflinkRouteRoute,
  } as any);
const IntegrationsSageIntacctIndexRoute =
  IntegrationsSageIntacctIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => IntegrationsSageIntacctRouteRoute,
  } as any);
const InventoryCountsNewRoute = InventoryCountsNewRouteImport.update({
  id: '/counts/new',
  path: '/counts/new',
  getParentRoute: () => InventoryRouteRoute,
} as any);
const ManufacturingWorkOrdersIndexRoute =
  ManufacturingWorkOrdersIndexRouteImport.update({
    id: '/work-orders/',
    path: '/work-orders/',
    getParentRoute: () => ManufacturingRoute,
  } as any);
const ManufacturingWorkOrdersWorkOrderIdRoute =
  ManufacturingWorkOrdersWorkOrderIdRouteImport.update({
    id: '/work-orders/$workOrderId',
    path: '/work-orders/$workOrderId',
    getParentRoute: () => ManufacturingRoute,
  } as any);
const PartsNewIndexRoute = PartsNewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PartsNewRouteRoute,
} as any);
const ReceivingReturnsSalesOrderIdRoute =
  ReceivingReturnsSalesOrderIdRouteImport.update({
    id: '/returns/$salesOrderId',
    path: '/returns/$salesOrderId',
    getParentRoute: () => ReceivingRoute,
  } as any);
const ReceivingTransferTransferOrderIdRoute =
  ReceivingTransferTransferOrderIdRouteImport.update({
    id: '/transfer/$transferOrderId',
    path: '/transfer/$transferOrderId',
    getParentRoute: () => ReceivingRoute,
  } as any);
const WarehousesLocationGroupIdIndexRoute =
  WarehousesLocationGroupIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WarehousesLocationGroupIdRouteRoute,
  } as any);
const WarehousesLocationGroupIdLocationIdRoute =
  WarehousesLocationGroupIdLocationIdRouteImport.update({
    id: '/$locationId',
    path: '/$locationId',
    getParentRoute: () => WarehousesLocationGroupIdRouteRoute,
  } as any);
const WarehousesLocationGroupIdNewRoute =
  WarehousesLocationGroupIdNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => WarehousesLocationGroupIdRouteRoute,
  } as any);
const IntegrationsLeaflinkLeafLinkIntegrationIdIndexRoute =
  IntegrationsLeaflinkLeafLinkIntegrationIdIndexRouteImport.update({
    id: '/$leafLinkIntegrationId/',
    path: '/$leafLinkIntegrationId/',
    getParentRoute: () => IntegrationsLeaflinkRouteRoute,
  } as any);
const IntegrationsLeaflinkLeafLinkIntegrationIdCustomersRoute =
  IntegrationsLeaflinkLeafLinkIntegrationIdCustomersRouteImport.update({
    id: '/$leafLinkIntegrationId/customers',
    path: '/$leafLinkIntegrationId/customers',
    getParentRoute: () => IntegrationsLeaflinkRouteRoute,
  } as any);
const IntegrationsLeaflinkLeafLinkIntegrationIdHeldOrdersRoute =
  IntegrationsLeaflinkLeafLinkIntegrationIdHeldOrdersRouteImport.update({
    id: '/$leafLinkIntegrationId/held-orders',
    path: '/$leafLinkIntegrationId/held-orders',
    getParentRoute: () => IntegrationsLeaflinkRouteRoute,
  } as any);
const IntegrationsLeaflinkLeafLinkIntegrationIdListProductsRoute =
  IntegrationsLeaflinkLeafLinkIntegrationIdListProductsRouteImport.update({
    id: '/$leafLinkIntegrationId/list-products',
    path: '/$leafLinkIntegrationId/list-products',
    getParentRoute: () => IntegrationsLeaflinkRouteRoute,
  } as any);
const IntegrationsLeaflinkLeafLinkIntegrationIdOrdersRoute =
  IntegrationsLeaflinkLeafLinkIntegrationIdOrdersRouteImport.update({
    id: '/$leafLinkIntegrationId/orders',
    path: '/$leafLinkIntegrationId/orders',
    getParentRoute: () => IntegrationsLeaflinkRouteRoute,
  } as any);
const IntegrationsLeaflinkLeafLinkIntegrationIdProductsRoute =
  IntegrationsLeaflinkLeafLinkIntegrationIdProductsRouteImport.update({
    id: '/$leafLinkIntegrationId/products',
    path: '/$leafLinkIntegrationId/products',
    getParentRoute: () => IntegrationsLeaflinkRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/accounts-receivable': typeof AccountsReceivableRouteRouteWithChildren;
  '/boms': typeof BomsRouteRouteWithChildren;
  '/brands': typeof BrandsRouteRouteWithChildren;
  '/company-settings': typeof CompanySettingsRouteRouteWithChildren;
  '/company-setup': typeof CompanySetupRouteRouteWithChildren;
  '/credits': typeof CreditsRouteRouteWithChildren;
  '/customers': typeof CustomersRouteRouteWithChildren;
  '/departments': typeof DepartmentsRouteRouteWithChildren;
  '/design-system': typeof DesignSystemRouteRouteWithChildren;
  '/inventory': typeof InventoryRouteRouteWithChildren;
  '/invoices': typeof InvoicesRouteRouteWithChildren;
  '/location-groups': typeof LocationGroupsRouteRouteWithChildren;
  '/locations': typeof LocationsRouteRouteWithChildren;
  '/parts': typeof PartsRouteRouteWithChildren;
  '/picking': typeof PickingRouteRouteWithChildren;
  '/pricing': typeof PricingRouteRouteWithChildren;
  '/pricing-rules': typeof PricingRulesRouteRouteWithChildren;
  '/product-categories': typeof ProductCategoriesRouteRouteWithChildren;
  '/products': typeof ProductsRouteRouteWithChildren;
  '/roles': typeof RolesRouteRouteWithChildren;
  '/sales-orders': typeof SalesOrdersRouteRouteWithChildren;
  '/transfer-orders': typeof TransferOrdersRouteRouteWithChildren;
  '/users': typeof UsersRouteRouteWithChildren;
  '/vendors': typeof VendorsRouteRouteWithChildren;
  '/warehouses': typeof WarehousesRouteRouteWithChildren;
  '/audit-trail': typeof AuditTrailRouteWithChildren;
  '/login': typeof LoginRoute;
  '/manufacturing': typeof ManufacturingRouteWithChildren;
  '/purchase-orders': typeof PurchaseOrdersRouteWithChildren;
  '/receiving': typeof ReceivingRouteWithChildren;
  '/supplier-returns': typeof SupplierReturnsRouteWithChildren;
  '/integrations/leaflink': typeof IntegrationsLeaflinkRouteRouteWithChildren;
  '/integrations/sage-intacct': typeof IntegrationsSageIntacctRouteRouteWithChildren;
  '/parts/new': typeof PartsNewRouteRouteWithChildren;
  '/warehouses/$locationGroupId': typeof WarehousesLocationGroupIdRouteRouteWithChildren;
  '/boms/$bomId': typeof BomsBomIdRoute;
  '/boms/new': typeof BomsNewRoute;
  '/brands/$brandId': typeof BrandsBrandIdRoute;
  '/brands/new': typeof BrandsNewRoute;
  '/credits/$creditId': typeof CreditsCreditIdRoute;
  '/customers/$customerId': typeof CustomersCustomerIdRoute;
  '/customers/new': typeof CustomersNewRoute;
  '/departments/$departmentId': typeof DepartmentsDepartmentIdRoute;
  '/departments/new': typeof DepartmentsNewRoute;
  '/design-system/accordion': typeof DesignSystemAccordionRoute;
  '/design-system/alert': typeof DesignSystemAlertRoute;
  '/design-system/aspect-ratio': typeof DesignSystemAspectRatioRoute;
  '/design-system/attachment': typeof DesignSystemAttachmentRoute;
  '/design-system/avatar': typeof DesignSystemAvatarRoute;
  '/design-system/breadcrumb': typeof DesignSystemBreadcrumbRoute;
  '/design-system/button': typeof DesignSystemButtonRoute;
  '/design-system/button-group': typeof DesignSystemButtonGroupRoute;
  '/design-system/calendar': typeof DesignSystemCalendarRoute;
  '/design-system/card': typeof DesignSystemCardRoute;
  '/design-system/card-shell': typeof DesignSystemCardShellRoute;
  '/design-system/checkbox': typeof DesignSystemCheckboxRoute;
  '/design-system/chip': typeof DesignSystemChipRoute;
  '/design-system/collapsible': typeof DesignSystemCollapsibleRoute;
  '/design-system/combobox': typeof DesignSystemComboboxRoute;
  '/design-system/data-table': typeof DesignSystemDataTableRoute;
  '/design-system/date-picker': typeof DesignSystemDatePickerRoute;
  '/design-system/detail-card-shell': typeof DesignSystemDetailCardShellRoute;
  '/design-system/detail-page-states': typeof DesignSystemDetailPageStatesRoute;
  '/design-system/dialog': typeof DesignSystemDialogRoute;
  '/design-system/dropdown-menu': typeof DesignSystemDropdownMenuRoute;
  '/design-system/editable-cell': typeof DesignSystemEditableCellRoute;
  '/design-system/empty': typeof DesignSystemEmptyRoute;
  '/design-system/field': typeof DesignSystemFieldRoute;
  '/design-system/filter-button': typeof DesignSystemFilterButtonRoute;
  '/design-system/input': typeof DesignSystemInputRoute;
  '/design-system/input-group': typeof DesignSystemInputGroupRoute;
  '/design-system/item': typeof DesignSystemItemRoute;
  '/design-system/label': typeof DesignSystemLabelRoute;
  '/design-system/menubar': typeof DesignSystemMenubarRoute;
  '/design-system/nested-table': typeof DesignSystemNestedTableRoute;
  '/design-system/radio-group': typeof DesignSystemRadioGroupRoute;
  '/design-system/resizable': typeof DesignSystemResizableRoute;
  '/design-system/scroll-area': typeof DesignSystemScrollAreaRoute;
  '/design-system/select': typeof DesignSystemSelectRoute;
  '/design-system/separator': typeof DesignSystemSeparatorRoute;
  '/design-system/sheet': typeof DesignSystemSheetRoute;
  '/design-system/sidebar': typeof DesignSystemSidebarRoute;
  '/design-system/sonner': typeof DesignSystemSonnerRoute;
  '/design-system/spinner': typeof DesignSystemSpinnerRoute;
  '/design-system/switch': typeof DesignSystemSwitchRoute;
  '/design-system/table': typeof DesignSystemTableRoute;
  '/design-system/tabs': typeof DesignSystemTabsRoute;
  '/design-system/textarea': typeof DesignSystemTextareaRoute;
  '/design-system/toggle': typeof DesignSystemToggleRoute;
  '/design-system/toggle-group': typeof DesignSystemToggleGroupRoute;
  '/design-system/tooltip': typeof DesignSystemTooltipRoute;
  '/design-system/tree-combobox': typeof DesignSystemTreeComboboxRoute;
  '/design-system/tree-table': typeof DesignSystemTreeTableRoute;
  '/design-system/wizard': typeof DesignSystemWizardRoute;
  '/events/$eventId': typeof EventsEventIdRoute;
  '/events/awaiting-approval': typeof EventsAwaitingApprovalRoute;
  '/events/awaiting-review': typeof EventsAwaitingReviewRoute;
  '/events/contacts': typeof EventsContactsRoute;
  '/events/new': typeof EventsNewRoute;
  '/events/tags': typeof EventsTagsRoute;
  '/inventory/lot-history': typeof InventoryLotHistoryRoute;
  '/inventory/tags': typeof InventoryTagsRoute;
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute;
  '/leaflink-companies/$': typeof LeaflinkCompaniesSplatRoute;
  '/location-groups/$locationGroupId': typeof LocationGroupsLocationGroupIdRoute;
  '/location-groups/new': typeof LocationGroupsNewRoute;
  '/locations/$locationId': typeof LocationsLocationIdRoute;
  '/locations/new': typeof LocationsNewRoute;
  '/manufacturing/$manufacturingOrderId': typeof ManufacturingManufacturingOrderIdRoute;
  '/manufacturing/new': typeof ManufacturingNewRoute;
  '/oauth/consent': typeof OauthConsentRoute;
  '/parts/$partId': typeof PartsPartIdRoute;
  '/pricing-rules/$priceRuleId': typeof PricingRulesPriceRuleIdRoute;
  '/product-categories/$productTreeId': typeof ProductCategoriesProductTreeIdRoute;
  '/products/$productId': typeof ProductsProductIdRoute;
  '/products/new': typeof ProductsNewRoute;
  '/purchase-orders/$purchaseOrderId': typeof PurchaseOrdersPurchaseOrderIdRoute;
  '/purchase-orders/new': typeof PurchaseOrdersNewRoute;
  '/receiving/$purchaseOrderId': typeof ReceivingPurchaseOrderIdRoute;
  '/roles/$roleId': typeof RolesRoleIdRoute;
  '/roles/new': typeof RolesNewRoute;
  '/sales-orders/$salesOrderId': typeof SalesOrdersSalesOrderIdRoute;
  '/sales-orders/new': typeof SalesOrdersNewRoute;
  '/transfer-orders/$transferOrderId': typeof TransferOrdersTransferOrderIdRoute;
  '/transfer-orders/new': typeof TransferOrdersNewRoute;
  '/users/$userId': typeof UsersUserIdRoute;
  '/vendors/$vendorId': typeof VendorsVendorIdRoute;
  '/vendors/new': typeof VendorsNewRoute;
  '/warehouses/new': typeof WarehousesNewRoute;
  '/accounts-receivable/': typeof AccountsReceivableIndexRoute;
  '/audit-trail/': typeof AuditTrailIndexRoute;
  '/boms/': typeof BomsIndexRoute;
  '/brands/': typeof BrandsIndexRoute;
  '/company-settings/': typeof CompanySettingsIndexRoute;
  '/company-setup/': typeof CompanySetupIndexRoute;
  '/credits/': typeof CreditsIndexRoute;
  '/custom-reports/': typeof CustomReportsIndexRoute;
  '/customers/': typeof CustomersIndexRoute;
  '/departments/': typeof DepartmentsIndexRoute;
  '/design-system/': typeof DesignSystemIndexRoute;
  '/events/': typeof EventsIndexRoute;
  '/inventory/': typeof InventoryIndexRoute;
  '/invoices/': typeof InvoicesIndexRoute;
  '/location-groups/': typeof LocationGroupsIndexRoute;
  '/locations/': typeof LocationsIndexRoute;
  '/manufacturing/': typeof ManufacturingIndexRoute;
  '/parts/': typeof PartsIndexRoute;
  '/picking/': typeof PickingIndexRoute;
  '/pricing-rules/': typeof PricingRulesIndexRoute;
  '/pricing/': typeof PricingIndexRoute;
  '/product-categories/': typeof ProductCategoriesIndexRoute;
  '/products/': typeof ProductsIndexRoute;
  '/purchase-orders/': typeof PurchaseOrdersIndexRoute;
  '/receiving/': typeof ReceivingIndexRoute;
  '/roles/': typeof RolesIndexRoute;
  '/sales-orders/': typeof SalesOrdersIndexRoute;
  '/supplier-returns/': typeof SupplierReturnsIndexRoute;
  '/transfer-orders/': typeof TransferOrdersIndexRoute;
  '/users/': typeof UsersIndexRoute;
  '/vendors/': typeof VendorsIndexRoute;
  '/warehouses/': typeof WarehousesIndexRoute;
  '/events/templates/$templateVersionId': typeof EventsTemplatesTemplateVersionIdRoute;
  '/events/templates/new': typeof EventsTemplatesNewRoute;
  '/inventory/counts/new': typeof InventoryCountsNewRoute;
  '/manufacturing/work-orders/$workOrderId': typeof ManufacturingWorkOrdersWorkOrderIdRoute;
  '/receiving/returns/$salesOrderId': typeof ReceivingReturnsSalesOrderIdRoute;
  '/receiving/transfer/$transferOrderId': typeof ReceivingTransferTransferOrderIdRoute;
  '/warehouses/$locationGroupId/$locationId': typeof WarehousesLocationGroupIdLocationIdRoute;
  '/warehouses/$locationGroupId/new': typeof WarehousesLocationGroupIdNewRoute;
  '/events/templates/': typeof EventsTemplatesIndexRoute;
  '/integrations/leaflink/': typeof IntegrationsLeaflinkIndexRoute;
  '/integrations/sage-intacct/': typeof IntegrationsSageIntacctIndexRoute;
  '/manufacturing/work-orders/': typeof ManufacturingWorkOrdersIndexRoute;
  '/parts/new/': typeof PartsNewIndexRoute;
  '/warehouses/$locationGroupId/': typeof WarehousesLocationGroupIdIndexRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/customers': typeof IntegrationsLeaflinkLeafLinkIntegrationIdCustomersRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/held-orders': typeof IntegrationsLeaflinkLeafLinkIntegrationIdHeldOrdersRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/list-products': typeof IntegrationsLeaflinkLeafLinkIntegrationIdListProductsRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/orders': typeof IntegrationsLeaflinkLeafLinkIntegrationIdOrdersRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/products': typeof IntegrationsLeaflinkLeafLinkIntegrationIdProductsRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/': typeof IntegrationsLeaflinkLeafLinkIntegrationIdIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/login': typeof LoginRoute;
  '/boms/$bomId': typeof BomsBomIdRoute;
  '/boms/new': typeof BomsNewRoute;
  '/brands/$brandId': typeof BrandsBrandIdRoute;
  '/brands/new': typeof BrandsNewRoute;
  '/credits/$creditId': typeof CreditsCreditIdRoute;
  '/customers/$customerId': typeof CustomersCustomerIdRoute;
  '/customers/new': typeof CustomersNewRoute;
  '/departments/$departmentId': typeof DepartmentsDepartmentIdRoute;
  '/departments/new': typeof DepartmentsNewRoute;
  '/design-system/accordion': typeof DesignSystemAccordionRoute;
  '/design-system/alert': typeof DesignSystemAlertRoute;
  '/design-system/aspect-ratio': typeof DesignSystemAspectRatioRoute;
  '/design-system/attachment': typeof DesignSystemAttachmentRoute;
  '/design-system/avatar': typeof DesignSystemAvatarRoute;
  '/design-system/breadcrumb': typeof DesignSystemBreadcrumbRoute;
  '/design-system/button': typeof DesignSystemButtonRoute;
  '/design-system/button-group': typeof DesignSystemButtonGroupRoute;
  '/design-system/calendar': typeof DesignSystemCalendarRoute;
  '/design-system/card': typeof DesignSystemCardRoute;
  '/design-system/card-shell': typeof DesignSystemCardShellRoute;
  '/design-system/checkbox': typeof DesignSystemCheckboxRoute;
  '/design-system/chip': typeof DesignSystemChipRoute;
  '/design-system/collapsible': typeof DesignSystemCollapsibleRoute;
  '/design-system/combobox': typeof DesignSystemComboboxRoute;
  '/design-system/data-table': typeof DesignSystemDataTableRoute;
  '/design-system/date-picker': typeof DesignSystemDatePickerRoute;
  '/design-system/detail-card-shell': typeof DesignSystemDetailCardShellRoute;
  '/design-system/detail-page-states': typeof DesignSystemDetailPageStatesRoute;
  '/design-system/dialog': typeof DesignSystemDialogRoute;
  '/design-system/dropdown-menu': typeof DesignSystemDropdownMenuRoute;
  '/design-system/editable-cell': typeof DesignSystemEditableCellRoute;
  '/design-system/empty': typeof DesignSystemEmptyRoute;
  '/design-system/field': typeof DesignSystemFieldRoute;
  '/design-system/filter-button': typeof DesignSystemFilterButtonRoute;
  '/design-system/input': typeof DesignSystemInputRoute;
  '/design-system/input-group': typeof DesignSystemInputGroupRoute;
  '/design-system/item': typeof DesignSystemItemRoute;
  '/design-system/label': typeof DesignSystemLabelRoute;
  '/design-system/menubar': typeof DesignSystemMenubarRoute;
  '/design-system/nested-table': typeof DesignSystemNestedTableRoute;
  '/design-system/radio-group': typeof DesignSystemRadioGroupRoute;
  '/design-system/resizable': typeof DesignSystemResizableRoute;
  '/design-system/scroll-area': typeof DesignSystemScrollAreaRoute;
  '/design-system/select': typeof DesignSystemSelectRoute;
  '/design-system/separator': typeof DesignSystemSeparatorRoute;
  '/design-system/sheet': typeof DesignSystemSheetRoute;
  '/design-system/sidebar': typeof DesignSystemSidebarRoute;
  '/design-system/sonner': typeof DesignSystemSonnerRoute;
  '/design-system/spinner': typeof DesignSystemSpinnerRoute;
  '/design-system/switch': typeof DesignSystemSwitchRoute;
  '/design-system/table': typeof DesignSystemTableRoute;
  '/design-system/tabs': typeof DesignSystemTabsRoute;
  '/design-system/textarea': typeof DesignSystemTextareaRoute;
  '/design-system/toggle': typeof DesignSystemToggleRoute;
  '/design-system/toggle-group': typeof DesignSystemToggleGroupRoute;
  '/design-system/tooltip': typeof DesignSystemTooltipRoute;
  '/design-system/tree-combobox': typeof DesignSystemTreeComboboxRoute;
  '/design-system/tree-table': typeof DesignSystemTreeTableRoute;
  '/design-system/wizard': typeof DesignSystemWizardRoute;
  '/events/$eventId': typeof EventsEventIdRoute;
  '/events/awaiting-approval': typeof EventsAwaitingApprovalRoute;
  '/events/awaiting-review': typeof EventsAwaitingReviewRoute;
  '/events/contacts': typeof EventsContactsRoute;
  '/events/new': typeof EventsNewRoute;
  '/events/tags': typeof EventsTagsRoute;
  '/inventory/lot-history': typeof InventoryLotHistoryRoute;
  '/inventory/tags': typeof InventoryTagsRoute;
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute;
  '/leaflink-companies/$': typeof LeaflinkCompaniesSplatRoute;
  '/location-groups/$locationGroupId': typeof LocationGroupsLocationGroupIdRoute;
  '/location-groups/new': typeof LocationGroupsNewRoute;
  '/locations/$locationId': typeof LocationsLocationIdRoute;
  '/locations/new': typeof LocationsNewRoute;
  '/manufacturing/$manufacturingOrderId': typeof ManufacturingManufacturingOrderIdRoute;
  '/manufacturing/new': typeof ManufacturingNewRoute;
  '/oauth/consent': typeof OauthConsentRoute;
  '/parts/$partId': typeof PartsPartIdRoute;
  '/pricing-rules/$priceRuleId': typeof PricingRulesPriceRuleIdRoute;
  '/product-categories/$productTreeId': typeof ProductCategoriesProductTreeIdRoute;
  '/products/$productId': typeof ProductsProductIdRoute;
  '/products/new': typeof ProductsNewRoute;
  '/purchase-orders/$purchaseOrderId': typeof PurchaseOrdersPurchaseOrderIdRoute;
  '/purchase-orders/new': typeof PurchaseOrdersNewRoute;
  '/receiving/$purchaseOrderId': typeof ReceivingPurchaseOrderIdRoute;
  '/roles/$roleId': typeof RolesRoleIdRoute;
  '/roles/new': typeof RolesNewRoute;
  '/sales-orders/$salesOrderId': typeof SalesOrdersSalesOrderIdRoute;
  '/sales-orders/new': typeof SalesOrdersNewRoute;
  '/transfer-orders/$transferOrderId': typeof TransferOrdersTransferOrderIdRoute;
  '/transfer-orders/new': typeof TransferOrdersNewRoute;
  '/users/$userId': typeof UsersUserIdRoute;
  '/vendors/$vendorId': typeof VendorsVendorIdRoute;
  '/vendors/new': typeof VendorsNewRoute;
  '/warehouses/new': typeof WarehousesNewRoute;
  '/accounts-receivable': typeof AccountsReceivableIndexRoute;
  '/audit-trail': typeof AuditTrailIndexRoute;
  '/boms': typeof BomsIndexRoute;
  '/brands': typeof BrandsIndexRoute;
  '/company-settings': typeof CompanySettingsIndexRoute;
  '/company-setup': typeof CompanySetupIndexRoute;
  '/credits': typeof CreditsIndexRoute;
  '/custom-reports': typeof CustomReportsIndexRoute;
  '/customers': typeof CustomersIndexRoute;
  '/departments': typeof DepartmentsIndexRoute;
  '/design-system': typeof DesignSystemIndexRoute;
  '/events': typeof EventsIndexRoute;
  '/inventory': typeof InventoryIndexRoute;
  '/invoices': typeof InvoicesIndexRoute;
  '/location-groups': typeof LocationGroupsIndexRoute;
  '/locations': typeof LocationsIndexRoute;
  '/manufacturing': typeof ManufacturingIndexRoute;
  '/parts': typeof PartsIndexRoute;
  '/picking': typeof PickingIndexRoute;
  '/pricing-rules': typeof PricingRulesIndexRoute;
  '/pricing': typeof PricingIndexRoute;
  '/product-categories': typeof ProductCategoriesIndexRoute;
  '/products': typeof ProductsIndexRoute;
  '/purchase-orders': typeof PurchaseOrdersIndexRoute;
  '/receiving': typeof ReceivingIndexRoute;
  '/roles': typeof RolesIndexRoute;
  '/sales-orders': typeof SalesOrdersIndexRoute;
  '/supplier-returns': typeof SupplierReturnsIndexRoute;
  '/transfer-orders': typeof TransferOrdersIndexRoute;
  '/users': typeof UsersIndexRoute;
  '/vendors': typeof VendorsIndexRoute;
  '/warehouses': typeof WarehousesIndexRoute;
  '/events/templates/$templateVersionId': typeof EventsTemplatesTemplateVersionIdRoute;
  '/events/templates/new': typeof EventsTemplatesNewRoute;
  '/inventory/counts/new': typeof InventoryCountsNewRoute;
  '/manufacturing/work-orders/$workOrderId': typeof ManufacturingWorkOrdersWorkOrderIdRoute;
  '/receiving/returns/$salesOrderId': typeof ReceivingReturnsSalesOrderIdRoute;
  '/receiving/transfer/$transferOrderId': typeof ReceivingTransferTransferOrderIdRoute;
  '/warehouses/$locationGroupId/$locationId': typeof WarehousesLocationGroupIdLocationIdRoute;
  '/warehouses/$locationGroupId/new': typeof WarehousesLocationGroupIdNewRoute;
  '/events/templates': typeof EventsTemplatesIndexRoute;
  '/integrations/leaflink': typeof IntegrationsLeaflinkIndexRoute;
  '/integrations/sage-intacct': typeof IntegrationsSageIntacctIndexRoute;
  '/manufacturing/work-orders': typeof ManufacturingWorkOrdersIndexRoute;
  '/parts/new': typeof PartsNewIndexRoute;
  '/warehouses/$locationGroupId': typeof WarehousesLocationGroupIdIndexRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/customers': typeof IntegrationsLeaflinkLeafLinkIntegrationIdCustomersRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/held-orders': typeof IntegrationsLeaflinkLeafLinkIntegrationIdHeldOrdersRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/list-products': typeof IntegrationsLeaflinkLeafLinkIntegrationIdListProductsRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/orders': typeof IntegrationsLeaflinkLeafLinkIntegrationIdOrdersRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/products': typeof IntegrationsLeaflinkLeafLinkIntegrationIdProductsRoute;
  '/integrations/leaflink/$leafLinkIntegrationId': typeof IntegrationsLeaflinkLeafLinkIntegrationIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/accounts-receivable': typeof AccountsReceivableRouteRouteWithChildren;
  '/boms': typeof BomsRouteRouteWithChildren;
  '/brands': typeof BrandsRouteRouteWithChildren;
  '/company-settings': typeof CompanySettingsRouteRouteWithChildren;
  '/company-setup': typeof CompanySetupRouteRouteWithChildren;
  '/credits': typeof CreditsRouteRouteWithChildren;
  '/customers': typeof CustomersRouteRouteWithChildren;
  '/departments': typeof DepartmentsRouteRouteWithChildren;
  '/design-system': typeof DesignSystemRouteRouteWithChildren;
  '/inventory': typeof InventoryRouteRouteWithChildren;
  '/invoices': typeof InvoicesRouteRouteWithChildren;
  '/location-groups': typeof LocationGroupsRouteRouteWithChildren;
  '/locations': typeof LocationsRouteRouteWithChildren;
  '/parts': typeof PartsRouteRouteWithChildren;
  '/picking': typeof PickingRouteRouteWithChildren;
  '/pricing': typeof PricingRouteRouteWithChildren;
  '/pricing-rules': typeof PricingRulesRouteRouteWithChildren;
  '/product-categories': typeof ProductCategoriesRouteRouteWithChildren;
  '/products': typeof ProductsRouteRouteWithChildren;
  '/roles': typeof RolesRouteRouteWithChildren;
  '/sales-orders': typeof SalesOrdersRouteRouteWithChildren;
  '/transfer-orders': typeof TransferOrdersRouteRouteWithChildren;
  '/users': typeof UsersRouteRouteWithChildren;
  '/vendors': typeof VendorsRouteRouteWithChildren;
  '/warehouses': typeof WarehousesRouteRouteWithChildren;
  '/audit-trail': typeof AuditTrailRouteWithChildren;
  '/login': typeof LoginRoute;
  '/manufacturing': typeof ManufacturingRouteWithChildren;
  '/purchase-orders': typeof PurchaseOrdersRouteWithChildren;
  '/receiving': typeof ReceivingRouteWithChildren;
  '/supplier-returns': typeof SupplierReturnsRouteWithChildren;
  '/integrations/leaflink': typeof IntegrationsLeaflinkRouteRouteWithChildren;
  '/integrations/sage-intacct': typeof IntegrationsSageIntacctRouteRouteWithChildren;
  '/parts/new': typeof PartsNewRouteRouteWithChildren;
  '/warehouses/$locationGroupId': typeof WarehousesLocationGroupIdRouteRouteWithChildren;
  '/boms/$bomId': typeof BomsBomIdRoute;
  '/boms/new': typeof BomsNewRoute;
  '/brands/$brandId': typeof BrandsBrandIdRoute;
  '/brands/new': typeof BrandsNewRoute;
  '/credits/$creditId': typeof CreditsCreditIdRoute;
  '/customers/$customerId': typeof CustomersCustomerIdRoute;
  '/customers/new': typeof CustomersNewRoute;
  '/departments/$departmentId': typeof DepartmentsDepartmentIdRoute;
  '/departments/new': typeof DepartmentsNewRoute;
  '/design-system/accordion': typeof DesignSystemAccordionRoute;
  '/design-system/alert': typeof DesignSystemAlertRoute;
  '/design-system/aspect-ratio': typeof DesignSystemAspectRatioRoute;
  '/design-system/attachment': typeof DesignSystemAttachmentRoute;
  '/design-system/avatar': typeof DesignSystemAvatarRoute;
  '/design-system/breadcrumb': typeof DesignSystemBreadcrumbRoute;
  '/design-system/button': typeof DesignSystemButtonRoute;
  '/design-system/button-group': typeof DesignSystemButtonGroupRoute;
  '/design-system/calendar': typeof DesignSystemCalendarRoute;
  '/design-system/card': typeof DesignSystemCardRoute;
  '/design-system/card-shell': typeof DesignSystemCardShellRoute;
  '/design-system/checkbox': typeof DesignSystemCheckboxRoute;
  '/design-system/chip': typeof DesignSystemChipRoute;
  '/design-system/collapsible': typeof DesignSystemCollapsibleRoute;
  '/design-system/combobox': typeof DesignSystemComboboxRoute;
  '/design-system/data-table': typeof DesignSystemDataTableRoute;
  '/design-system/date-picker': typeof DesignSystemDatePickerRoute;
  '/design-system/detail-card-shell': typeof DesignSystemDetailCardShellRoute;
  '/design-system/detail-page-states': typeof DesignSystemDetailPageStatesRoute;
  '/design-system/dialog': typeof DesignSystemDialogRoute;
  '/design-system/dropdown-menu': typeof DesignSystemDropdownMenuRoute;
  '/design-system/editable-cell': typeof DesignSystemEditableCellRoute;
  '/design-system/empty': typeof DesignSystemEmptyRoute;
  '/design-system/field': typeof DesignSystemFieldRoute;
  '/design-system/filter-button': typeof DesignSystemFilterButtonRoute;
  '/design-system/input': typeof DesignSystemInputRoute;
  '/design-system/input-group': typeof DesignSystemInputGroupRoute;
  '/design-system/item': typeof DesignSystemItemRoute;
  '/design-system/label': typeof DesignSystemLabelRoute;
  '/design-system/menubar': typeof DesignSystemMenubarRoute;
  '/design-system/nested-table': typeof DesignSystemNestedTableRoute;
  '/design-system/radio-group': typeof DesignSystemRadioGroupRoute;
  '/design-system/resizable': typeof DesignSystemResizableRoute;
  '/design-system/scroll-area': typeof DesignSystemScrollAreaRoute;
  '/design-system/select': typeof DesignSystemSelectRoute;
  '/design-system/separator': typeof DesignSystemSeparatorRoute;
  '/design-system/sheet': typeof DesignSystemSheetRoute;
  '/design-system/sidebar': typeof DesignSystemSidebarRoute;
  '/design-system/sonner': typeof DesignSystemSonnerRoute;
  '/design-system/spinner': typeof DesignSystemSpinnerRoute;
  '/design-system/switch': typeof DesignSystemSwitchRoute;
  '/design-system/table': typeof DesignSystemTableRoute;
  '/design-system/tabs': typeof DesignSystemTabsRoute;
  '/design-system/textarea': typeof DesignSystemTextareaRoute;
  '/design-system/toggle': typeof DesignSystemToggleRoute;
  '/design-system/toggle-group': typeof DesignSystemToggleGroupRoute;
  '/design-system/tooltip': typeof DesignSystemTooltipRoute;
  '/design-system/tree-combobox': typeof DesignSystemTreeComboboxRoute;
  '/design-system/tree-table': typeof DesignSystemTreeTableRoute;
  '/design-system/wizard': typeof DesignSystemWizardRoute;
  '/events/$eventId': typeof EventsEventIdRoute;
  '/events/awaiting-approval': typeof EventsAwaitingApprovalRoute;
  '/events/awaiting-review': typeof EventsAwaitingReviewRoute;
  '/events/contacts': typeof EventsContactsRoute;
  '/events/new': typeof EventsNewRoute;
  '/events/tags': typeof EventsTagsRoute;
  '/inventory/lot-history': typeof InventoryLotHistoryRoute;
  '/inventory/tags': typeof InventoryTagsRoute;
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute;
  '/leaflink-companies/$': typeof LeaflinkCompaniesSplatRoute;
  '/location-groups/$locationGroupId': typeof LocationGroupsLocationGroupIdRoute;
  '/location-groups/new': typeof LocationGroupsNewRoute;
  '/locations/$locationId': typeof LocationsLocationIdRoute;
  '/locations/new': typeof LocationsNewRoute;
  '/manufacturing/$manufacturingOrderId': typeof ManufacturingManufacturingOrderIdRoute;
  '/manufacturing/new': typeof ManufacturingNewRoute;
  '/oauth/consent': typeof OauthConsentRoute;
  '/parts/$partId': typeof PartsPartIdRoute;
  '/pricing-rules/$priceRuleId': typeof PricingRulesPriceRuleIdRoute;
  '/product-categories/$productTreeId': typeof ProductCategoriesProductTreeIdRoute;
  '/products/$productId': typeof ProductsProductIdRoute;
  '/products/new': typeof ProductsNewRoute;
  '/purchase-orders/$purchaseOrderId': typeof PurchaseOrdersPurchaseOrderIdRoute;
  '/purchase-orders/new': typeof PurchaseOrdersNewRoute;
  '/receiving/$purchaseOrderId': typeof ReceivingPurchaseOrderIdRoute;
  '/roles/$roleId': typeof RolesRoleIdRoute;
  '/roles/new': typeof RolesNewRoute;
  '/sales-orders/$salesOrderId': typeof SalesOrdersSalesOrderIdRoute;
  '/sales-orders/new': typeof SalesOrdersNewRoute;
  '/transfer-orders/$transferOrderId': typeof TransferOrdersTransferOrderIdRoute;
  '/transfer-orders/new': typeof TransferOrdersNewRoute;
  '/users/$userId': typeof UsersUserIdRoute;
  '/vendors/$vendorId': typeof VendorsVendorIdRoute;
  '/vendors/new': typeof VendorsNewRoute;
  '/warehouses/new': typeof WarehousesNewRoute;
  '/accounts-receivable/': typeof AccountsReceivableIndexRoute;
  '/audit-trail/': typeof AuditTrailIndexRoute;
  '/boms/': typeof BomsIndexRoute;
  '/brands/': typeof BrandsIndexRoute;
  '/company-settings/': typeof CompanySettingsIndexRoute;
  '/company-setup/': typeof CompanySetupIndexRoute;
  '/credits/': typeof CreditsIndexRoute;
  '/custom-reports/': typeof CustomReportsIndexRoute;
  '/customers/': typeof CustomersIndexRoute;
  '/departments/': typeof DepartmentsIndexRoute;
  '/design-system/': typeof DesignSystemIndexRoute;
  '/events/': typeof EventsIndexRoute;
  '/inventory/': typeof InventoryIndexRoute;
  '/invoices/': typeof InvoicesIndexRoute;
  '/location-groups/': typeof LocationGroupsIndexRoute;
  '/locations/': typeof LocationsIndexRoute;
  '/manufacturing/': typeof ManufacturingIndexRoute;
  '/parts/': typeof PartsIndexRoute;
  '/picking/': typeof PickingIndexRoute;
  '/pricing-rules/': typeof PricingRulesIndexRoute;
  '/pricing/': typeof PricingIndexRoute;
  '/product-categories/': typeof ProductCategoriesIndexRoute;
  '/products/': typeof ProductsIndexRoute;
  '/purchase-orders/': typeof PurchaseOrdersIndexRoute;
  '/receiving/': typeof ReceivingIndexRoute;
  '/roles/': typeof RolesIndexRoute;
  '/sales-orders/': typeof SalesOrdersIndexRoute;
  '/supplier-returns/': typeof SupplierReturnsIndexRoute;
  '/transfer-orders/': typeof TransferOrdersIndexRoute;
  '/users/': typeof UsersIndexRoute;
  '/vendors/': typeof VendorsIndexRoute;
  '/warehouses/': typeof WarehousesIndexRoute;
  '/events/templates/$templateVersionId': typeof EventsTemplatesTemplateVersionIdRoute;
  '/events/templates/new': typeof EventsTemplatesNewRoute;
  '/inventory/counts/new': typeof InventoryCountsNewRoute;
  '/manufacturing/work-orders/$workOrderId': typeof ManufacturingWorkOrdersWorkOrderIdRoute;
  '/receiving/returns/$salesOrderId': typeof ReceivingReturnsSalesOrderIdRoute;
  '/receiving/transfer/$transferOrderId': typeof ReceivingTransferTransferOrderIdRoute;
  '/warehouses/$locationGroupId/$locationId': typeof WarehousesLocationGroupIdLocationIdRoute;
  '/warehouses/$locationGroupId/new': typeof WarehousesLocationGroupIdNewRoute;
  '/events/templates/': typeof EventsTemplatesIndexRoute;
  '/integrations/leaflink/': typeof IntegrationsLeaflinkIndexRoute;
  '/integrations/sage-intacct/': typeof IntegrationsSageIntacctIndexRoute;
  '/manufacturing/work-orders/': typeof ManufacturingWorkOrdersIndexRoute;
  '/parts/new/': typeof PartsNewIndexRoute;
  '/warehouses/$locationGroupId/': typeof WarehousesLocationGroupIdIndexRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/customers': typeof IntegrationsLeaflinkLeafLinkIntegrationIdCustomersRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/held-orders': typeof IntegrationsLeaflinkLeafLinkIntegrationIdHeldOrdersRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/list-products': typeof IntegrationsLeaflinkLeafLinkIntegrationIdListProductsRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/orders': typeof IntegrationsLeaflinkLeafLinkIntegrationIdOrdersRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/products': typeof IntegrationsLeaflinkLeafLinkIntegrationIdProductsRoute;
  '/integrations/leaflink/$leafLinkIntegrationId/': typeof IntegrationsLeaflinkLeafLinkIntegrationIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/accounts-receivable'
    | '/boms'
    | '/brands'
    | '/company-settings'
    | '/company-setup'
    | '/credits'
    | '/customers'
    | '/departments'
    | '/design-system'
    | '/inventory'
    | '/invoices'
    | '/location-groups'
    | '/locations'
    | '/parts'
    | '/picking'
    | '/pricing'
    | '/pricing-rules'
    | '/product-categories'
    | '/products'
    | '/roles'
    | '/sales-orders'
    | '/transfer-orders'
    | '/users'
    | '/vendors'
    | '/warehouses'
    | '/audit-trail'
    | '/login'
    | '/manufacturing'
    | '/purchase-orders'
    | '/receiving'
    | '/supplier-returns'
    | '/integrations/leaflink'
    | '/integrations/sage-intacct'
    | '/parts/new'
    | '/warehouses/$locationGroupId'
    | '/boms/$bomId'
    | '/boms/new'
    | '/brands/$brandId'
    | '/brands/new'
    | '/credits/$creditId'
    | '/customers/$customerId'
    | '/customers/new'
    | '/departments/$departmentId'
    | '/departments/new'
    | '/design-system/accordion'
    | '/design-system/alert'
    | '/design-system/aspect-ratio'
    | '/design-system/attachment'
    | '/design-system/avatar'
    | '/design-system/breadcrumb'
    | '/design-system/button'
    | '/design-system/button-group'
    | '/design-system/calendar'
    | '/design-system/card'
    | '/design-system/card-shell'
    | '/design-system/checkbox'
    | '/design-system/chip'
    | '/design-system/collapsible'
    | '/design-system/combobox'
    | '/design-system/data-table'
    | '/design-system/date-picker'
    | '/design-system/detail-card-shell'
    | '/design-system/detail-page-states'
    | '/design-system/dialog'
    | '/design-system/dropdown-menu'
    | '/design-system/editable-cell'
    | '/design-system/empty'
    | '/design-system/field'
    | '/design-system/filter-button'
    | '/design-system/input'
    | '/design-system/input-group'
    | '/design-system/item'
    | '/design-system/label'
    | '/design-system/menubar'
    | '/design-system/nested-table'
    | '/design-system/radio-group'
    | '/design-system/resizable'
    | '/design-system/scroll-area'
    | '/design-system/select'
    | '/design-system/separator'
    | '/design-system/sheet'
    | '/design-system/sidebar'
    | '/design-system/sonner'
    | '/design-system/spinner'
    | '/design-system/switch'
    | '/design-system/table'
    | '/design-system/tabs'
    | '/design-system/textarea'
    | '/design-system/toggle'
    | '/design-system/toggle-group'
    | '/design-system/tooltip'
    | '/design-system/tree-combobox'
    | '/design-system/tree-table'
    | '/design-system/wizard'
    | '/events/$eventId'
    | '/events/awaiting-approval'
    | '/events/awaiting-review'
    | '/events/contacts'
    | '/events/new'
    | '/events/tags'
    | '/inventory/lot-history'
    | '/inventory/tags'
    | '/invoices/$invoiceId'
    | '/leaflink-companies/$'
    | '/location-groups/$locationGroupId'
    | '/location-groups/new'
    | '/locations/$locationId'
    | '/locations/new'
    | '/manufacturing/$manufacturingOrderId'
    | '/manufacturing/new'
    | '/oauth/consent'
    | '/parts/$partId'
    | '/pricing-rules/$priceRuleId'
    | '/product-categories/$productTreeId'
    | '/products/$productId'
    | '/products/new'
    | '/purchase-orders/$purchaseOrderId'
    | '/purchase-orders/new'
    | '/receiving/$purchaseOrderId'
    | '/roles/$roleId'
    | '/roles/new'
    | '/sales-orders/$salesOrderId'
    | '/sales-orders/new'
    | '/transfer-orders/$transferOrderId'
    | '/transfer-orders/new'
    | '/users/$userId'
    | '/vendors/$vendorId'
    | '/vendors/new'
    | '/warehouses/new'
    | '/accounts-receivable/'
    | '/audit-trail/'
    | '/boms/'
    | '/brands/'
    | '/company-settings/'
    | '/company-setup/'
    | '/credits/'
    | '/custom-reports/'
    | '/customers/'
    | '/departments/'
    | '/design-system/'
    | '/events/'
    | '/inventory/'
    | '/invoices/'
    | '/location-groups/'
    | '/locations/'
    | '/manufacturing/'
    | '/parts/'
    | '/picking/'
    | '/pricing-rules/'
    | '/pricing/'
    | '/product-categories/'
    | '/products/'
    | '/purchase-orders/'
    | '/receiving/'
    | '/roles/'
    | '/sales-orders/'
    | '/supplier-returns/'
    | '/transfer-orders/'
    | '/users/'
    | '/vendors/'
    | '/warehouses/'
    | '/events/templates/$templateVersionId'
    | '/events/templates/new'
    | '/inventory/counts/new'
    | '/manufacturing/work-orders/$workOrderId'
    | '/receiving/returns/$salesOrderId'
    | '/receiving/transfer/$transferOrderId'
    | '/warehouses/$locationGroupId/$locationId'
    | '/warehouses/$locationGroupId/new'
    | '/events/templates/'
    | '/integrations/leaflink/'
    | '/integrations/sage-intacct/'
    | '/manufacturing/work-orders/'
    | '/parts/new/'
    | '/warehouses/$locationGroupId/'
    | '/integrations/leaflink/$leafLinkIntegrationId/customers'
    | '/integrations/leaflink/$leafLinkIntegrationId/held-orders'
    | '/integrations/leaflink/$leafLinkIntegrationId/list-products'
    | '/integrations/leaflink/$leafLinkIntegrationId/orders'
    | '/integrations/leaflink/$leafLinkIntegrationId/products'
    | '/integrations/leaflink/$leafLinkIntegrationId/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/login'
    | '/boms/$bomId'
    | '/boms/new'
    | '/brands/$brandId'
    | '/brands/new'
    | '/credits/$creditId'
    | '/customers/$customerId'
    | '/customers/new'
    | '/departments/$departmentId'
    | '/departments/new'
    | '/design-system/accordion'
    | '/design-system/alert'
    | '/design-system/aspect-ratio'
    | '/design-system/attachment'
    | '/design-system/avatar'
    | '/design-system/breadcrumb'
    | '/design-system/button'
    | '/design-system/button-group'
    | '/design-system/calendar'
    | '/design-system/card'
    | '/design-system/card-shell'
    | '/design-system/checkbox'
    | '/design-system/chip'
    | '/design-system/collapsible'
    | '/design-system/combobox'
    | '/design-system/data-table'
    | '/design-system/date-picker'
    | '/design-system/detail-card-shell'
    | '/design-system/detail-page-states'
    | '/design-system/dialog'
    | '/design-system/dropdown-menu'
    | '/design-system/editable-cell'
    | '/design-system/empty'
    | '/design-system/field'
    | '/design-system/filter-button'
    | '/design-system/input'
    | '/design-system/input-group'
    | '/design-system/item'
    | '/design-system/label'
    | '/design-system/menubar'
    | '/design-system/nested-table'
    | '/design-system/radio-group'
    | '/design-system/resizable'
    | '/design-system/scroll-area'
    | '/design-system/select'
    | '/design-system/separator'
    | '/design-system/sheet'
    | '/design-system/sidebar'
    | '/design-system/sonner'
    | '/design-system/spinner'
    | '/design-system/switch'
    | '/design-system/table'
    | '/design-system/tabs'
    | '/design-system/textarea'
    | '/design-system/toggle'
    | '/design-system/toggle-group'
    | '/design-system/tooltip'
    | '/design-system/tree-combobox'
    | '/design-system/tree-table'
    | '/design-system/wizard'
    | '/events/$eventId'
    | '/events/awaiting-approval'
    | '/events/awaiting-review'
    | '/events/contacts'
    | '/events/new'
    | '/events/tags'
    | '/inventory/lot-history'
    | '/inventory/tags'
    | '/invoices/$invoiceId'
    | '/leaflink-companies/$'
    | '/location-groups/$locationGroupId'
    | '/location-groups/new'
    | '/locations/$locationId'
    | '/locations/new'
    | '/manufacturing/$manufacturingOrderId'
    | '/manufacturing/new'
    | '/oauth/consent'
    | '/parts/$partId'
    | '/pricing-rules/$priceRuleId'
    | '/product-categories/$productTreeId'
    | '/products/$productId'
    | '/products/new'
    | '/purchase-orders/$purchaseOrderId'
    | '/purchase-orders/new'
    | '/receiving/$purchaseOrderId'
    | '/roles/$roleId'
    | '/roles/new'
    | '/sales-orders/$salesOrderId'
    | '/sales-orders/new'
    | '/transfer-orders/$transferOrderId'
    | '/transfer-orders/new'
    | '/users/$userId'
    | '/vendors/$vendorId'
    | '/vendors/new'
    | '/warehouses/new'
    | '/accounts-receivable'
    | '/audit-trail'
    | '/boms'
    | '/brands'
    | '/company-settings'
    | '/company-setup'
    | '/credits'
    | '/custom-reports'
    | '/customers'
    | '/departments'
    | '/design-system'
    | '/events'
    | '/inventory'
    | '/invoices'
    | '/location-groups'
    | '/locations'
    | '/manufacturing'
    | '/parts'
    | '/picking'
    | '/pricing-rules'
    | '/pricing'
    | '/product-categories'
    | '/products'
    | '/purchase-orders'
    | '/receiving'
    | '/roles'
    | '/sales-orders'
    | '/supplier-returns'
    | '/transfer-orders'
    | '/users'
    | '/vendors'
    | '/warehouses'
    | '/events/templates/$templateVersionId'
    | '/events/templates/new'
    | '/inventory/counts/new'
    | '/manufacturing/work-orders/$workOrderId'
    | '/receiving/returns/$salesOrderId'
    | '/receiving/transfer/$transferOrderId'
    | '/warehouses/$locationGroupId/$locationId'
    | '/warehouses/$locationGroupId/new'
    | '/events/templates'
    | '/integrations/leaflink'
    | '/integrations/sage-intacct'
    | '/manufacturing/work-orders'
    | '/parts/new'
    | '/warehouses/$locationGroupId'
    | '/integrations/leaflink/$leafLinkIntegrationId/customers'
    | '/integrations/leaflink/$leafLinkIntegrationId/held-orders'
    | '/integrations/leaflink/$leafLinkIntegrationId/list-products'
    | '/integrations/leaflink/$leafLinkIntegrationId/orders'
    | '/integrations/leaflink/$leafLinkIntegrationId/products'
    | '/integrations/leaflink/$leafLinkIntegrationId';
  id:
    | '__root__'
    | '/'
    | '/accounts-receivable'
    | '/boms'
    | '/brands'
    | '/company-settings'
    | '/company-setup'
    | '/credits'
    | '/customers'
    | '/departments'
    | '/design-system'
    | '/inventory'
    | '/invoices'
    | '/location-groups'
    | '/locations'
    | '/parts'
    | '/picking'
    | '/pricing'
    | '/pricing-rules'
    | '/product-categories'
    | '/products'
    | '/roles'
    | '/sales-orders'
    | '/transfer-orders'
    | '/users'
    | '/vendors'
    | '/warehouses'
    | '/audit-trail'
    | '/login'
    | '/manufacturing'
    | '/purchase-orders'
    | '/receiving'
    | '/supplier-returns'
    | '/integrations/leaflink'
    | '/integrations/sage-intacct'
    | '/parts/new'
    | '/warehouses/$locationGroupId'
    | '/boms/$bomId'
    | '/boms/new'
    | '/brands/$brandId'
    | '/brands/new'
    | '/credits/$creditId'
    | '/customers/$customerId'
    | '/customers/new'
    | '/departments/$departmentId'
    | '/departments/new'
    | '/design-system/accordion'
    | '/design-system/alert'
    | '/design-system/aspect-ratio'
    | '/design-system/attachment'
    | '/design-system/avatar'
    | '/design-system/breadcrumb'
    | '/design-system/button'
    | '/design-system/button-group'
    | '/design-system/calendar'
    | '/design-system/card'
    | '/design-system/card-shell'
    | '/design-system/checkbox'
    | '/design-system/chip'
    | '/design-system/collapsible'
    | '/design-system/combobox'
    | '/design-system/data-table'
    | '/design-system/date-picker'
    | '/design-system/detail-card-shell'
    | '/design-system/detail-page-states'
    | '/design-system/dialog'
    | '/design-system/dropdown-menu'
    | '/design-system/editable-cell'
    | '/design-system/empty'
    | '/design-system/field'
    | '/design-system/filter-button'
    | '/design-system/input'
    | '/design-system/input-group'
    | '/design-system/item'
    | '/design-system/label'
    | '/design-system/menubar'
    | '/design-system/nested-table'
    | '/design-system/radio-group'
    | '/design-system/resizable'
    | '/design-system/scroll-area'
    | '/design-system/select'
    | '/design-system/separator'
    | '/design-system/sheet'
    | '/design-system/sidebar'
    | '/design-system/sonner'
    | '/design-system/spinner'
    | '/design-system/switch'
    | '/design-system/table'
    | '/design-system/tabs'
    | '/design-system/textarea'
    | '/design-system/toggle'
    | '/design-system/toggle-group'
    | '/design-system/tooltip'
    | '/design-system/tree-combobox'
    | '/design-system/tree-table'
    | '/design-system/wizard'
    | '/events/$eventId'
    | '/events/awaiting-approval'
    | '/events/awaiting-review'
    | '/events/contacts'
    | '/events/new'
    | '/events/tags'
    | '/inventory/lot-history'
    | '/inventory/tags'
    | '/invoices/$invoiceId'
    | '/leaflink-companies/$'
    | '/location-groups/$locationGroupId'
    | '/location-groups/new'
    | '/locations/$locationId'
    | '/locations/new'
    | '/manufacturing/$manufacturingOrderId'
    | '/manufacturing/new'
    | '/oauth/consent'
    | '/parts/$partId'
    | '/pricing-rules/$priceRuleId'
    | '/product-categories/$productTreeId'
    | '/products/$productId'
    | '/products/new'
    | '/purchase-orders/$purchaseOrderId'
    | '/purchase-orders/new'
    | '/receiving/$purchaseOrderId'
    | '/roles/$roleId'
    | '/roles/new'
    | '/sales-orders/$salesOrderId'
    | '/sales-orders/new'
    | '/transfer-orders/$transferOrderId'
    | '/transfer-orders/new'
    | '/users/$userId'
    | '/vendors/$vendorId'
    | '/vendors/new'
    | '/warehouses/new'
    | '/accounts-receivable/'
    | '/audit-trail/'
    | '/boms/'
    | '/brands/'
    | '/company-settings/'
    | '/company-setup/'
    | '/credits/'
    | '/custom-reports/'
    | '/customers/'
    | '/departments/'
    | '/design-system/'
    | '/events/'
    | '/inventory/'
    | '/invoices/'
    | '/location-groups/'
    | '/locations/'
    | '/manufacturing/'
    | '/parts/'
    | '/picking/'
    | '/pricing-rules/'
    | '/pricing/'
    | '/product-categories/'
    | '/products/'
    | '/purchase-orders/'
    | '/receiving/'
    | '/roles/'
    | '/sales-orders/'
    | '/supplier-returns/'
    | '/transfer-orders/'
    | '/users/'
    | '/vendors/'
    | '/warehouses/'
    | '/events/templates/$templateVersionId'
    | '/events/templates/new'
    | '/inventory/counts/new'
    | '/manufacturing/work-orders/$workOrderId'
    | '/receiving/returns/$salesOrderId'
    | '/receiving/transfer/$transferOrderId'
    | '/warehouses/$locationGroupId/$locationId'
    | '/warehouses/$locationGroupId/new'
    | '/events/templates/'
    | '/integrations/leaflink/'
    | '/integrations/sage-intacct/'
    | '/manufacturing/work-orders/'
    | '/parts/new/'
    | '/warehouses/$locationGroupId/'
    | '/integrations/leaflink/$leafLinkIntegrationId/customers'
    | '/integrations/leaflink/$leafLinkIntegrationId/held-orders'
    | '/integrations/leaflink/$leafLinkIntegrationId/list-products'
    | '/integrations/leaflink/$leafLinkIntegrationId/orders'
    | '/integrations/leaflink/$leafLinkIntegrationId/products'
    | '/integrations/leaflink/$leafLinkIntegrationId/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AccountsReceivableRouteRoute: typeof AccountsReceivableRouteRouteWithChildren;
  BomsRouteRoute: typeof BomsRouteRouteWithChildren;
  BrandsRouteRoute: typeof BrandsRouteRouteWithChildren;
  CompanySettingsRouteRoute: typeof CompanySettingsRouteRouteWithChildren;
  CompanySetupRouteRoute: typeof CompanySetupRouteRouteWithChildren;
  CreditsRouteRoute: typeof CreditsRouteRouteWithChildren;
  CustomersRouteRoute: typeof CustomersRouteRouteWithChildren;
  DepartmentsRouteRoute: typeof DepartmentsRouteRouteWithChildren;
  DesignSystemRouteRoute: typeof DesignSystemRouteRouteWithChildren;
  InventoryRouteRoute: typeof InventoryRouteRouteWithChildren;
  InvoicesRouteRoute: typeof InvoicesRouteRouteWithChildren;
  LocationGroupsRouteRoute: typeof LocationGroupsRouteRouteWithChildren;
  LocationsRouteRoute: typeof LocationsRouteRouteWithChildren;
  PartsRouteRoute: typeof PartsRouteRouteWithChildren;
  PickingRouteRoute: typeof PickingRouteRouteWithChildren;
  PricingRouteRoute: typeof PricingRouteRouteWithChildren;
  PricingRulesRouteRoute: typeof PricingRulesRouteRouteWithChildren;
  ProductCategoriesRouteRoute: typeof ProductCategoriesRouteRouteWithChildren;
  ProductsRouteRoute: typeof ProductsRouteRouteWithChildren;
  RolesRouteRoute: typeof RolesRouteRouteWithChildren;
  SalesOrdersRouteRoute: typeof SalesOrdersRouteRouteWithChildren;
  TransferOrdersRouteRoute: typeof TransferOrdersRouteRouteWithChildren;
  UsersRouteRoute: typeof UsersRouteRouteWithChildren;
  VendorsRouteRoute: typeof VendorsRouteRouteWithChildren;
  WarehousesRouteRoute: typeof WarehousesRouteRouteWithChildren;
  AuditTrailRoute: typeof AuditTrailRouteWithChildren;
  LoginRoute: typeof LoginRoute;
  ManufacturingRoute: typeof ManufacturingRouteWithChildren;
  PurchaseOrdersRoute: typeof PurchaseOrdersRouteWithChildren;
  ReceivingRoute: typeof ReceivingRouteWithChildren;
  SupplierReturnsRoute: typeof SupplierReturnsRouteWithChildren;
  IntegrationsLeaflinkRouteRoute: typeof IntegrationsLeaflinkRouteRouteWithChildren;
  IntegrationsSageIntacctRouteRoute: typeof IntegrationsSageIntacctRouteRouteWithChildren;
  EventsEventIdRoute: typeof EventsEventIdRoute;
  EventsAwaitingApprovalRoute: typeof EventsAwaitingApprovalRoute;
  EventsAwaitingReviewRoute: typeof EventsAwaitingReviewRoute;
  EventsContactsRoute: typeof EventsContactsRoute;
  EventsNewRoute: typeof EventsNewRoute;
  EventsTagsRoute: typeof EventsTagsRoute;
  LeaflinkCompaniesSplatRoute: typeof LeaflinkCompaniesSplatRoute;
  OauthConsentRoute: typeof OauthConsentRoute;
  CustomReportsIndexRoute: typeof CustomReportsIndexRoute;
  EventsIndexRoute: typeof EventsIndexRoute;
  EventsTemplatesTemplateVersionIdRoute: typeof EventsTemplatesTemplateVersionIdRoute;
  EventsTemplatesNewRoute: typeof EventsTemplatesNewRoute;
  EventsTemplatesIndexRoute: typeof EventsTemplatesIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/accounts-receivable': {
      id: '/accounts-receivable';
      path: '/accounts-receivable';
      fullPath: '/accounts-receivable';
      preLoaderRoute: typeof AccountsReceivableRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/audit-trail': {
      id: '/audit-trail';
      path: '/audit-trail';
      fullPath: '/audit-trail';
      preLoaderRoute: typeof AuditTrailRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/boms': {
      id: '/boms';
      path: '/boms';
      fullPath: '/boms';
      preLoaderRoute: typeof BomsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/brands': {
      id: '/brands';
      path: '/brands';
      fullPath: '/brands';
      preLoaderRoute: typeof BrandsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/company-settings': {
      id: '/company-settings';
      path: '/company-settings';
      fullPath: '/company-settings';
      preLoaderRoute: typeof CompanySettingsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/company-setup': {
      id: '/company-setup';
      path: '/company-setup';
      fullPath: '/company-setup';
      preLoaderRoute: typeof CompanySetupRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/credits': {
      id: '/credits';
      path: '/credits';
      fullPath: '/credits';
      preLoaderRoute: typeof CreditsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/customers': {
      id: '/customers';
      path: '/customers';
      fullPath: '/customers';
      preLoaderRoute: typeof CustomersRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/departments': {
      id: '/departments';
      path: '/departments';
      fullPath: '/departments';
      preLoaderRoute: typeof DepartmentsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/design-system': {
      id: '/design-system';
      path: '/design-system';
      fullPath: '/design-system';
      preLoaderRoute: typeof DesignSystemRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/inventory': {
      id: '/inventory';
      path: '/inventory';
      fullPath: '/inventory';
      preLoaderRoute: typeof InventoryRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/invoices': {
      id: '/invoices';
      path: '/invoices';
      fullPath: '/invoices';
      preLoaderRoute: typeof InvoicesRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/location-groups': {
      id: '/location-groups';
      path: '/location-groups';
      fullPath: '/location-groups';
      preLoaderRoute: typeof LocationGroupsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/locations': {
      id: '/locations';
      path: '/locations';
      fullPath: '/locations';
      preLoaderRoute: typeof LocationsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/manufacturing': {
      id: '/manufacturing';
      path: '/manufacturing';
      fullPath: '/manufacturing';
      preLoaderRoute: typeof ManufacturingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/parts': {
      id: '/parts';
      path: '/parts';
      fullPath: '/parts';
      preLoaderRoute: typeof PartsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/picking': {
      id: '/picking';
      path: '/picking';
      fullPath: '/picking';
      preLoaderRoute: typeof PickingRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/pricing': {
      id: '/pricing';
      path: '/pricing';
      fullPath: '/pricing';
      preLoaderRoute: typeof PricingRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/pricing-rules': {
      id: '/pricing-rules';
      path: '/pricing-rules';
      fullPath: '/pricing-rules';
      preLoaderRoute: typeof PricingRulesRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/product-categories': {
      id: '/product-categories';
      path: '/product-categories';
      fullPath: '/product-categories';
      preLoaderRoute: typeof ProductCategoriesRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/products': {
      id: '/products';
      path: '/products';
      fullPath: '/products';
      preLoaderRoute: typeof ProductsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/purchase-orders': {
      id: '/purchase-orders';
      path: '/purchase-orders';
      fullPath: '/purchase-orders';
      preLoaderRoute: typeof PurchaseOrdersRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/receiving': {
      id: '/receiving';
      path: '/receiving';
      fullPath: '/receiving';
      preLoaderRoute: typeof ReceivingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/roles': {
      id: '/roles';
      path: '/roles';
      fullPath: '/roles';
      preLoaderRoute: typeof RolesRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sales-orders': {
      id: '/sales-orders';
      path: '/sales-orders';
      fullPath: '/sales-orders';
      preLoaderRoute: typeof SalesOrdersRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/supplier-returns': {
      id: '/supplier-returns';
      path: '/supplier-returns';
      fullPath: '/supplier-returns';
      preLoaderRoute: typeof SupplierReturnsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/transfer-orders': {
      id: '/transfer-orders';
      path: '/transfer-orders';
      fullPath: '/transfer-orders';
      preLoaderRoute: typeof TransferOrdersRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/users': {
      id: '/users';
      path: '/users';
      fullPath: '/users';
      preLoaderRoute: typeof UsersRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/vendors': {
      id: '/vendors';
      path: '/vendors';
      fullPath: '/vendors';
      preLoaderRoute: typeof VendorsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/warehouses': {
      id: '/warehouses';
      path: '/warehouses';
      fullPath: '/warehouses';
      preLoaderRoute: typeof WarehousesRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/accounts-receivable/': {
      id: '/accounts-receivable/';
      path: '/';
      fullPath: '/accounts-receivable/';
      preLoaderRoute: typeof AccountsReceivableIndexRouteImport;
      parentRoute: typeof AccountsReceivableRouteRoute;
    };
    '/audit-trail/': {
      id: '/audit-trail/';
      path: '/';
      fullPath: '/audit-trail/';
      preLoaderRoute: typeof AuditTrailIndexRouteImport;
      parentRoute: typeof AuditTrailRoute;
    };
    '/boms/': {
      id: '/boms/';
      path: '/';
      fullPath: '/boms/';
      preLoaderRoute: typeof BomsIndexRouteImport;
      parentRoute: typeof BomsRouteRoute;
    };
    '/boms/$bomId': {
      id: '/boms/$bomId';
      path: '/$bomId';
      fullPath: '/boms/$bomId';
      preLoaderRoute: typeof BomsBomIdRouteImport;
      parentRoute: typeof BomsRouteRoute;
    };
    '/boms/new': {
      id: '/boms/new';
      path: '/new';
      fullPath: '/boms/new';
      preLoaderRoute: typeof BomsNewRouteImport;
      parentRoute: typeof BomsRouteRoute;
    };
    '/brands/': {
      id: '/brands/';
      path: '/';
      fullPath: '/brands/';
      preLoaderRoute: typeof BrandsIndexRouteImport;
      parentRoute: typeof BrandsRouteRoute;
    };
    '/brands/$brandId': {
      id: '/brands/$brandId';
      path: '/$brandId';
      fullPath: '/brands/$brandId';
      preLoaderRoute: typeof BrandsBrandIdRouteImport;
      parentRoute: typeof BrandsRouteRoute;
    };
    '/brands/new': {
      id: '/brands/new';
      path: '/new';
      fullPath: '/brands/new';
      preLoaderRoute: typeof BrandsNewRouteImport;
      parentRoute: typeof BrandsRouteRoute;
    };
    '/company-settings/': {
      id: '/company-settings/';
      path: '/';
      fullPath: '/company-settings/';
      preLoaderRoute: typeof CompanySettingsIndexRouteImport;
      parentRoute: typeof CompanySettingsRouteRoute;
    };
    '/company-setup/': {
      id: '/company-setup/';
      path: '/';
      fullPath: '/company-setup/';
      preLoaderRoute: typeof CompanySetupIndexRouteImport;
      parentRoute: typeof CompanySetupRouteRoute;
    };
    '/credits/': {
      id: '/credits/';
      path: '/';
      fullPath: '/credits/';
      preLoaderRoute: typeof CreditsIndexRouteImport;
      parentRoute: typeof CreditsRouteRoute;
    };
    '/credits/$creditId': {
      id: '/credits/$creditId';
      path: '/$creditId';
      fullPath: '/credits/$creditId';
      preLoaderRoute: typeof CreditsCreditIdRouteImport;
      parentRoute: typeof CreditsRouteRoute;
    };
    '/custom-reports/': {
      id: '/custom-reports/';
      path: '/custom-reports';
      fullPath: '/custom-reports/';
      preLoaderRoute: typeof CustomReportsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/customers/': {
      id: '/customers/';
      path: '/';
      fullPath: '/customers/';
      preLoaderRoute: typeof CustomersIndexRouteImport;
      parentRoute: typeof CustomersRouteRoute;
    };
    '/customers/$customerId': {
      id: '/customers/$customerId';
      path: '/$customerId';
      fullPath: '/customers/$customerId';
      preLoaderRoute: typeof CustomersCustomerIdRouteImport;
      parentRoute: typeof CustomersRouteRoute;
    };
    '/customers/new': {
      id: '/customers/new';
      path: '/new';
      fullPath: '/customers/new';
      preLoaderRoute: typeof CustomersNewRouteImport;
      parentRoute: typeof CustomersRouteRoute;
    };
    '/departments/': {
      id: '/departments/';
      path: '/';
      fullPath: '/departments/';
      preLoaderRoute: typeof DepartmentsIndexRouteImport;
      parentRoute: typeof DepartmentsRouteRoute;
    };
    '/departments/$departmentId': {
      id: '/departments/$departmentId';
      path: '/$departmentId';
      fullPath: '/departments/$departmentId';
      preLoaderRoute: typeof DepartmentsDepartmentIdRouteImport;
      parentRoute: typeof DepartmentsRouteRoute;
    };
    '/departments/new': {
      id: '/departments/new';
      path: '/new';
      fullPath: '/departments/new';
      preLoaderRoute: typeof DepartmentsNewRouteImport;
      parentRoute: typeof DepartmentsRouteRoute;
    };
    '/design-system/': {
      id: '/design-system/';
      path: '/';
      fullPath: '/design-system/';
      preLoaderRoute: typeof DesignSystemIndexRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/accordion': {
      id: '/design-system/accordion';
      path: '/accordion';
      fullPath: '/design-system/accordion';
      preLoaderRoute: typeof DesignSystemAccordionRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/alert': {
      id: '/design-system/alert';
      path: '/alert';
      fullPath: '/design-system/alert';
      preLoaderRoute: typeof DesignSystemAlertRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/aspect-ratio': {
      id: '/design-system/aspect-ratio';
      path: '/aspect-ratio';
      fullPath: '/design-system/aspect-ratio';
      preLoaderRoute: typeof DesignSystemAspectRatioRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/attachment': {
      id: '/design-system/attachment';
      path: '/attachment';
      fullPath: '/design-system/attachment';
      preLoaderRoute: typeof DesignSystemAttachmentRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/avatar': {
      id: '/design-system/avatar';
      path: '/avatar';
      fullPath: '/design-system/avatar';
      preLoaderRoute: typeof DesignSystemAvatarRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/breadcrumb': {
      id: '/design-system/breadcrumb';
      path: '/breadcrumb';
      fullPath: '/design-system/breadcrumb';
      preLoaderRoute: typeof DesignSystemBreadcrumbRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/button': {
      id: '/design-system/button';
      path: '/button';
      fullPath: '/design-system/button';
      preLoaderRoute: typeof DesignSystemButtonRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/button-group': {
      id: '/design-system/button-group';
      path: '/button-group';
      fullPath: '/design-system/button-group';
      preLoaderRoute: typeof DesignSystemButtonGroupRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/calendar': {
      id: '/design-system/calendar';
      path: '/calendar';
      fullPath: '/design-system/calendar';
      preLoaderRoute: typeof DesignSystemCalendarRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/card': {
      id: '/design-system/card';
      path: '/card';
      fullPath: '/design-system/card';
      preLoaderRoute: typeof DesignSystemCardRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/card-shell': {
      id: '/design-system/card-shell';
      path: '/card-shell';
      fullPath: '/design-system/card-shell';
      preLoaderRoute: typeof DesignSystemCardShellRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/checkbox': {
      id: '/design-system/checkbox';
      path: '/checkbox';
      fullPath: '/design-system/checkbox';
      preLoaderRoute: typeof DesignSystemCheckboxRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/chip': {
      id: '/design-system/chip';
      path: '/chip';
      fullPath: '/design-system/chip';
      preLoaderRoute: typeof DesignSystemChipRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/collapsible': {
      id: '/design-system/collapsible';
      path: '/collapsible';
      fullPath: '/design-system/collapsible';
      preLoaderRoute: typeof DesignSystemCollapsibleRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/combobox': {
      id: '/design-system/combobox';
      path: '/combobox';
      fullPath: '/design-system/combobox';
      preLoaderRoute: typeof DesignSystemComboboxRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/data-table': {
      id: '/design-system/data-table';
      path: '/data-table';
      fullPath: '/design-system/data-table';
      preLoaderRoute: typeof DesignSystemDataTableRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/date-picker': {
      id: '/design-system/date-picker';
      path: '/date-picker';
      fullPath: '/design-system/date-picker';
      preLoaderRoute: typeof DesignSystemDatePickerRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/detail-card-shell': {
      id: '/design-system/detail-card-shell';
      path: '/detail-card-shell';
      fullPath: '/design-system/detail-card-shell';
      preLoaderRoute: typeof DesignSystemDetailCardShellRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/detail-page-states': {
      id: '/design-system/detail-page-states';
      path: '/detail-page-states';
      fullPath: '/design-system/detail-page-states';
      preLoaderRoute: typeof DesignSystemDetailPageStatesRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/dialog': {
      id: '/design-system/dialog';
      path: '/dialog';
      fullPath: '/design-system/dialog';
      preLoaderRoute: typeof DesignSystemDialogRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/dropdown-menu': {
      id: '/design-system/dropdown-menu';
      path: '/dropdown-menu';
      fullPath: '/design-system/dropdown-menu';
      preLoaderRoute: typeof DesignSystemDropdownMenuRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/editable-cell': {
      id: '/design-system/editable-cell';
      path: '/editable-cell';
      fullPath: '/design-system/editable-cell';
      preLoaderRoute: typeof DesignSystemEditableCellRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/empty': {
      id: '/design-system/empty';
      path: '/empty';
      fullPath: '/design-system/empty';
      preLoaderRoute: typeof DesignSystemEmptyRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/field': {
      id: '/design-system/field';
      path: '/field';
      fullPath: '/design-system/field';
      preLoaderRoute: typeof DesignSystemFieldRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/filter-button': {
      id: '/design-system/filter-button';
      path: '/filter-button';
      fullPath: '/design-system/filter-button';
      preLoaderRoute: typeof DesignSystemFilterButtonRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/input': {
      id: '/design-system/input';
      path: '/input';
      fullPath: '/design-system/input';
      preLoaderRoute: typeof DesignSystemInputRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/input-group': {
      id: '/design-system/input-group';
      path: '/input-group';
      fullPath: '/design-system/input-group';
      preLoaderRoute: typeof DesignSystemInputGroupRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/item': {
      id: '/design-system/item';
      path: '/item';
      fullPath: '/design-system/item';
      preLoaderRoute: typeof DesignSystemItemRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/label': {
      id: '/design-system/label';
      path: '/label';
      fullPath: '/design-system/label';
      preLoaderRoute: typeof DesignSystemLabelRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/menubar': {
      id: '/design-system/menubar';
      path: '/menubar';
      fullPath: '/design-system/menubar';
      preLoaderRoute: typeof DesignSystemMenubarRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/nested-table': {
      id: '/design-system/nested-table';
      path: '/nested-table';
      fullPath: '/design-system/nested-table';
      preLoaderRoute: typeof DesignSystemNestedTableRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/radio-group': {
      id: '/design-system/radio-group';
      path: '/radio-group';
      fullPath: '/design-system/radio-group';
      preLoaderRoute: typeof DesignSystemRadioGroupRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/resizable': {
      id: '/design-system/resizable';
      path: '/resizable';
      fullPath: '/design-system/resizable';
      preLoaderRoute: typeof DesignSystemResizableRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/scroll-area': {
      id: '/design-system/scroll-area';
      path: '/scroll-area';
      fullPath: '/design-system/scroll-area';
      preLoaderRoute: typeof DesignSystemScrollAreaRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/select': {
      id: '/design-system/select';
      path: '/select';
      fullPath: '/design-system/select';
      preLoaderRoute: typeof DesignSystemSelectRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/separator': {
      id: '/design-system/separator';
      path: '/separator';
      fullPath: '/design-system/separator';
      preLoaderRoute: typeof DesignSystemSeparatorRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/sheet': {
      id: '/design-system/sheet';
      path: '/sheet';
      fullPath: '/design-system/sheet';
      preLoaderRoute: typeof DesignSystemSheetRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/sidebar': {
      id: '/design-system/sidebar';
      path: '/sidebar';
      fullPath: '/design-system/sidebar';
      preLoaderRoute: typeof DesignSystemSidebarRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/sonner': {
      id: '/design-system/sonner';
      path: '/sonner';
      fullPath: '/design-system/sonner';
      preLoaderRoute: typeof DesignSystemSonnerRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/spinner': {
      id: '/design-system/spinner';
      path: '/spinner';
      fullPath: '/design-system/spinner';
      preLoaderRoute: typeof DesignSystemSpinnerRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/switch': {
      id: '/design-system/switch';
      path: '/switch';
      fullPath: '/design-system/switch';
      preLoaderRoute: typeof DesignSystemSwitchRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/table': {
      id: '/design-system/table';
      path: '/table';
      fullPath: '/design-system/table';
      preLoaderRoute: typeof DesignSystemTableRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/tabs': {
      id: '/design-system/tabs';
      path: '/tabs';
      fullPath: '/design-system/tabs';
      preLoaderRoute: typeof DesignSystemTabsRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/textarea': {
      id: '/design-system/textarea';
      path: '/textarea';
      fullPath: '/design-system/textarea';
      preLoaderRoute: typeof DesignSystemTextareaRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/toggle': {
      id: '/design-system/toggle';
      path: '/toggle';
      fullPath: '/design-system/toggle';
      preLoaderRoute: typeof DesignSystemToggleRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/toggle-group': {
      id: '/design-system/toggle-group';
      path: '/toggle-group';
      fullPath: '/design-system/toggle-group';
      preLoaderRoute: typeof DesignSystemToggleGroupRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/tooltip': {
      id: '/design-system/tooltip';
      path: '/tooltip';
      fullPath: '/design-system/tooltip';
      preLoaderRoute: typeof DesignSystemTooltipRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/tree-combobox': {
      id: '/design-system/tree-combobox';
      path: '/tree-combobox';
      fullPath: '/design-system/tree-combobox';
      preLoaderRoute: typeof DesignSystemTreeComboboxRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/tree-table': {
      id: '/design-system/tree-table';
      path: '/tree-table';
      fullPath: '/design-system/tree-table';
      preLoaderRoute: typeof DesignSystemTreeTableRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/design-system/wizard': {
      id: '/design-system/wizard';
      path: '/wizard';
      fullPath: '/design-system/wizard';
      preLoaderRoute: typeof DesignSystemWizardRouteImport;
      parentRoute: typeof DesignSystemRouteRoute;
    };
    '/events/': {
      id: '/events/';
      path: '/events';
      fullPath: '/events/';
      preLoaderRoute: typeof EventsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/events/$eventId': {
      id: '/events/$eventId';
      path: '/events/$eventId';
      fullPath: '/events/$eventId';
      preLoaderRoute: typeof EventsEventIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/events/awaiting-approval': {
      id: '/events/awaiting-approval';
      path: '/events/awaiting-approval';
      fullPath: '/events/awaiting-approval';
      preLoaderRoute: typeof EventsAwaitingApprovalRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/events/awaiting-review': {
      id: '/events/awaiting-review';
      path: '/events/awaiting-review';
      fullPath: '/events/awaiting-review';
      preLoaderRoute: typeof EventsAwaitingReviewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/events/contacts': {
      id: '/events/contacts';
      path: '/events/contacts';
      fullPath: '/events/contacts';
      preLoaderRoute: typeof EventsContactsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/events/new': {
      id: '/events/new';
      path: '/events/new';
      fullPath: '/events/new';
      preLoaderRoute: typeof EventsNewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/events/tags': {
      id: '/events/tags';
      path: '/events/tags';
      fullPath: '/events/tags';
      preLoaderRoute: typeof EventsTagsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/integrations/leaflink': {
      id: '/integrations/leaflink';
      path: '/integrations/leaflink';
      fullPath: '/integrations/leaflink';
      preLoaderRoute: typeof IntegrationsLeaflinkRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/integrations/sage-intacct': {
      id: '/integrations/sage-intacct';
      path: '/integrations/sage-intacct';
      fullPath: '/integrations/sage-intacct';
      preLoaderRoute: typeof IntegrationsSageIntacctRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/inventory/': {
      id: '/inventory/';
      path: '/';
      fullPath: '/inventory/';
      preLoaderRoute: typeof InventoryIndexRouteImport;
      parentRoute: typeof InventoryRouteRoute;
    };
    '/inventory/lot-history': {
      id: '/inventory/lot-history';
      path: '/lot-history';
      fullPath: '/inventory/lot-history';
      preLoaderRoute: typeof InventoryLotHistoryRouteImport;
      parentRoute: typeof InventoryRouteRoute;
    };
    '/inventory/tags': {
      id: '/inventory/tags';
      path: '/tags';
      fullPath: '/inventory/tags';
      preLoaderRoute: typeof InventoryTagsRouteImport;
      parentRoute: typeof InventoryRouteRoute;
    };
    '/invoices/': {
      id: '/invoices/';
      path: '/';
      fullPath: '/invoices/';
      preLoaderRoute: typeof InvoicesIndexRouteImport;
      parentRoute: typeof InvoicesRouteRoute;
    };
    '/invoices/$invoiceId': {
      id: '/invoices/$invoiceId';
      path: '/$invoiceId';
      fullPath: '/invoices/$invoiceId';
      preLoaderRoute: typeof InvoicesInvoiceIdRouteImport;
      parentRoute: typeof InvoicesRouteRoute;
    };
    '/leaflink-companies/$': {
      id: '/leaflink-companies/$';
      path: '/leaflink-companies/$';
      fullPath: '/leaflink-companies/$';
      preLoaderRoute: typeof LeaflinkCompaniesSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/location-groups/': {
      id: '/location-groups/';
      path: '/';
      fullPath: '/location-groups/';
      preLoaderRoute: typeof LocationGroupsIndexRouteImport;
      parentRoute: typeof LocationGroupsRouteRoute;
    };
    '/location-groups/$locationGroupId': {
      id: '/location-groups/$locationGroupId';
      path: '/$locationGroupId';
      fullPath: '/location-groups/$locationGroupId';
      preLoaderRoute: typeof LocationGroupsLocationGroupIdRouteImport;
      parentRoute: typeof LocationGroupsRouteRoute;
    };
    '/location-groups/new': {
      id: '/location-groups/new';
      path: '/new';
      fullPath: '/location-groups/new';
      preLoaderRoute: typeof LocationGroupsNewRouteImport;
      parentRoute: typeof LocationGroupsRouteRoute;
    };
    '/locations/': {
      id: '/locations/';
      path: '/';
      fullPath: '/locations/';
      preLoaderRoute: typeof LocationsIndexRouteImport;
      parentRoute: typeof LocationsRouteRoute;
    };
    '/locations/$locationId': {
      id: '/locations/$locationId';
      path: '/$locationId';
      fullPath: '/locations/$locationId';
      preLoaderRoute: typeof LocationsLocationIdRouteImport;
      parentRoute: typeof LocationsRouteRoute;
    };
    '/locations/new': {
      id: '/locations/new';
      path: '/new';
      fullPath: '/locations/new';
      preLoaderRoute: typeof LocationsNewRouteImport;
      parentRoute: typeof LocationsRouteRoute;
    };
    '/manufacturing/': {
      id: '/manufacturing/';
      path: '/';
      fullPath: '/manufacturing/';
      preLoaderRoute: typeof ManufacturingIndexRouteImport;
      parentRoute: typeof ManufacturingRoute;
    };
    '/manufacturing/$manufacturingOrderId': {
      id: '/manufacturing/$manufacturingOrderId';
      path: '/$manufacturingOrderId';
      fullPath: '/manufacturing/$manufacturingOrderId';
      preLoaderRoute: typeof ManufacturingManufacturingOrderIdRouteImport;
      parentRoute: typeof ManufacturingRoute;
    };
    '/manufacturing/new': {
      id: '/manufacturing/new';
      path: '/new';
      fullPath: '/manufacturing/new';
      preLoaderRoute: typeof ManufacturingNewRouteImport;
      parentRoute: typeof ManufacturingRoute;
    };
    '/oauth/consent': {
      id: '/oauth/consent';
      path: '/oauth/consent';
      fullPath: '/oauth/consent';
      preLoaderRoute: typeof OauthConsentRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/parts/': {
      id: '/parts/';
      path: '/';
      fullPath: '/parts/';
      preLoaderRoute: typeof PartsIndexRouteImport;
      parentRoute: typeof PartsRouteRoute;
    };
    '/parts/$partId': {
      id: '/parts/$partId';
      path: '/$partId';
      fullPath: '/parts/$partId';
      preLoaderRoute: typeof PartsPartIdRouteImport;
      parentRoute: typeof PartsRouteRoute;
    };
    '/parts/new': {
      id: '/parts/new';
      path: '/new';
      fullPath: '/parts/new';
      preLoaderRoute: typeof PartsNewRouteRouteImport;
      parentRoute: typeof PartsRouteRoute;
    };
    '/picking/': {
      id: '/picking/';
      path: '/';
      fullPath: '/picking/';
      preLoaderRoute: typeof PickingIndexRouteImport;
      parentRoute: typeof PickingRouteRoute;
    };
    '/pricing-rules/': {
      id: '/pricing-rules/';
      path: '/';
      fullPath: '/pricing-rules/';
      preLoaderRoute: typeof PricingRulesIndexRouteImport;
      parentRoute: typeof PricingRulesRouteRoute;
    };
    '/pricing-rules/$priceRuleId': {
      id: '/pricing-rules/$priceRuleId';
      path: '/$priceRuleId';
      fullPath: '/pricing-rules/$priceRuleId';
      preLoaderRoute: typeof PricingRulesPriceRuleIdRouteImport;
      parentRoute: typeof PricingRulesRouteRoute;
    };
    '/pricing/': {
      id: '/pricing/';
      path: '/';
      fullPath: '/pricing/';
      preLoaderRoute: typeof PricingIndexRouteImport;
      parentRoute: typeof PricingRouteRoute;
    };
    '/product-categories/': {
      id: '/product-categories/';
      path: '/';
      fullPath: '/product-categories/';
      preLoaderRoute: typeof ProductCategoriesIndexRouteImport;
      parentRoute: typeof ProductCategoriesRouteRoute;
    };
    '/product-categories/$productTreeId': {
      id: '/product-categories/$productTreeId';
      path: '/$productTreeId';
      fullPath: '/product-categories/$productTreeId';
      preLoaderRoute: typeof ProductCategoriesProductTreeIdRouteImport;
      parentRoute: typeof ProductCategoriesRouteRoute;
    };
    '/products/': {
      id: '/products/';
      path: '/';
      fullPath: '/products/';
      preLoaderRoute: typeof ProductsIndexRouteImport;
      parentRoute: typeof ProductsRouteRoute;
    };
    '/products/$productId': {
      id: '/products/$productId';
      path: '/$productId';
      fullPath: '/products/$productId';
      preLoaderRoute: typeof ProductsProductIdRouteImport;
      parentRoute: typeof ProductsRouteRoute;
    };
    '/products/new': {
      id: '/products/new';
      path: '/new';
      fullPath: '/products/new';
      preLoaderRoute: typeof ProductsNewRouteImport;
      parentRoute: typeof ProductsRouteRoute;
    };
    '/purchase-orders/': {
      id: '/purchase-orders/';
      path: '/';
      fullPath: '/purchase-orders/';
      preLoaderRoute: typeof PurchaseOrdersIndexRouteImport;
      parentRoute: typeof PurchaseOrdersRoute;
    };
    '/purchase-orders/$purchaseOrderId': {
      id: '/purchase-orders/$purchaseOrderId';
      path: '/$purchaseOrderId';
      fullPath: '/purchase-orders/$purchaseOrderId';
      preLoaderRoute: typeof PurchaseOrdersPurchaseOrderIdRouteImport;
      parentRoute: typeof PurchaseOrdersRoute;
    };
    '/purchase-orders/new': {
      id: '/purchase-orders/new';
      path: '/new';
      fullPath: '/purchase-orders/new';
      preLoaderRoute: typeof PurchaseOrdersNewRouteImport;
      parentRoute: typeof PurchaseOrdersRoute;
    };
    '/receiving/': {
      id: '/receiving/';
      path: '/';
      fullPath: '/receiving/';
      preLoaderRoute: typeof ReceivingIndexRouteImport;
      parentRoute: typeof ReceivingRoute;
    };
    '/receiving/$purchaseOrderId': {
      id: '/receiving/$purchaseOrderId';
      path: '/$purchaseOrderId';
      fullPath: '/receiving/$purchaseOrderId';
      preLoaderRoute: typeof ReceivingPurchaseOrderIdRouteImport;
      parentRoute: typeof ReceivingRoute;
    };
    '/roles/': {
      id: '/roles/';
      path: '/';
      fullPath: '/roles/';
      preLoaderRoute: typeof RolesIndexRouteImport;
      parentRoute: typeof RolesRouteRoute;
    };
    '/roles/$roleId': {
      id: '/roles/$roleId';
      path: '/$roleId';
      fullPath: '/roles/$roleId';
      preLoaderRoute: typeof RolesRoleIdRouteImport;
      parentRoute: typeof RolesRouteRoute;
    };
    '/roles/new': {
      id: '/roles/new';
      path: '/new';
      fullPath: '/roles/new';
      preLoaderRoute: typeof RolesNewRouteImport;
      parentRoute: typeof RolesRouteRoute;
    };
    '/sales-orders/': {
      id: '/sales-orders/';
      path: '/';
      fullPath: '/sales-orders/';
      preLoaderRoute: typeof SalesOrdersIndexRouteImport;
      parentRoute: typeof SalesOrdersRouteRoute;
    };
    '/sales-orders/$salesOrderId': {
      id: '/sales-orders/$salesOrderId';
      path: '/$salesOrderId';
      fullPath: '/sales-orders/$salesOrderId';
      preLoaderRoute: typeof SalesOrdersSalesOrderIdRouteImport;
      parentRoute: typeof SalesOrdersRouteRoute;
    };
    '/sales-orders/new': {
      id: '/sales-orders/new';
      path: '/new';
      fullPath: '/sales-orders/new';
      preLoaderRoute: typeof SalesOrdersNewRouteImport;
      parentRoute: typeof SalesOrdersRouteRoute;
    };
    '/supplier-returns/': {
      id: '/supplier-returns/';
      path: '/';
      fullPath: '/supplier-returns/';
      preLoaderRoute: typeof SupplierReturnsIndexRouteImport;
      parentRoute: typeof SupplierReturnsRoute;
    };
    '/transfer-orders/': {
      id: '/transfer-orders/';
      path: '/';
      fullPath: '/transfer-orders/';
      preLoaderRoute: typeof TransferOrdersIndexRouteImport;
      parentRoute: typeof TransferOrdersRouteRoute;
    };
    '/transfer-orders/$transferOrderId': {
      id: '/transfer-orders/$transferOrderId';
      path: '/$transferOrderId';
      fullPath: '/transfer-orders/$transferOrderId';
      preLoaderRoute: typeof TransferOrdersTransferOrderIdRouteImport;
      parentRoute: typeof TransferOrdersRouteRoute;
    };
    '/transfer-orders/new': {
      id: '/transfer-orders/new';
      path: '/new';
      fullPath: '/transfer-orders/new';
      preLoaderRoute: typeof TransferOrdersNewRouteImport;
      parentRoute: typeof TransferOrdersRouteRoute;
    };
    '/users/': {
      id: '/users/';
      path: '/';
      fullPath: '/users/';
      preLoaderRoute: typeof UsersIndexRouteImport;
      parentRoute: typeof UsersRouteRoute;
    };
    '/users/$userId': {
      id: '/users/$userId';
      path: '/$userId';
      fullPath: '/users/$userId';
      preLoaderRoute: typeof UsersUserIdRouteImport;
      parentRoute: typeof UsersRouteRoute;
    };
    '/vendors/': {
      id: '/vendors/';
      path: '/';
      fullPath: '/vendors/';
      preLoaderRoute: typeof VendorsIndexRouteImport;
      parentRoute: typeof VendorsRouteRoute;
    };
    '/vendors/$vendorId': {
      id: '/vendors/$vendorId';
      path: '/$vendorId';
      fullPath: '/vendors/$vendorId';
      preLoaderRoute: typeof VendorsVendorIdRouteImport;
      parentRoute: typeof VendorsRouteRoute;
    };
    '/vendors/new': {
      id: '/vendors/new';
      path: '/new';
      fullPath: '/vendors/new';
      preLoaderRoute: typeof VendorsNewRouteImport;
      parentRoute: typeof VendorsRouteRoute;
    };
    '/warehouses/': {
      id: '/warehouses/';
      path: '/';
      fullPath: '/warehouses/';
      preLoaderRoute: typeof WarehousesIndexRouteImport;
      parentRoute: typeof WarehousesRouteRoute;
    };
    '/warehouses/$locationGroupId': {
      id: '/warehouses/$locationGroupId';
      path: '/$locationGroupId';
      fullPath: '/warehouses/$locationGroupId';
      preLoaderRoute: typeof WarehousesLocationGroupIdRouteRouteImport;
      parentRoute: typeof WarehousesRouteRoute;
    };
    '/warehouses/new': {
      id: '/warehouses/new';
      path: '/new';
      fullPath: '/warehouses/new';
      preLoaderRoute: typeof WarehousesNewRouteImport;
      parentRoute: typeof WarehousesRouteRoute;
    };
    '/events/templates/': {
      id: '/events/templates/';
      path: '/events/templates';
      fullPath: '/events/templates/';
      preLoaderRoute: typeof EventsTemplatesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/events/templates/$templateVersionId': {
      id: '/events/templates/$templateVersionId';
      path: '/events/templates/$templateVersionId';
      fullPath: '/events/templates/$templateVersionId';
      preLoaderRoute: typeof EventsTemplatesTemplateVersionIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/events/templates/new': {
      id: '/events/templates/new';
      path: '/events/templates/new';
      fullPath: '/events/templates/new';
      preLoaderRoute: typeof EventsTemplatesNewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/integrations/leaflink/': {
      id: '/integrations/leaflink/';
      path: '/';
      fullPath: '/integrations/leaflink/';
      preLoaderRoute: typeof IntegrationsLeaflinkIndexRouteImport;
      parentRoute: typeof IntegrationsLeaflinkRouteRoute;
    };
    '/integrations/sage-intacct/': {
      id: '/integrations/sage-intacct/';
      path: '/';
      fullPath: '/integrations/sage-intacct/';
      preLoaderRoute: typeof IntegrationsSageIntacctIndexRouteImport;
      parentRoute: typeof IntegrationsSageIntacctRouteRoute;
    };
    '/inventory/counts/new': {
      id: '/inventory/counts/new';
      path: '/counts/new';
      fullPath: '/inventory/counts/new';
      preLoaderRoute: typeof InventoryCountsNewRouteImport;
      parentRoute: typeof InventoryRouteRoute;
    };
    '/manufacturing/work-orders/': {
      id: '/manufacturing/work-orders/';
      path: '/work-orders';
      fullPath: '/manufacturing/work-orders/';
      preLoaderRoute: typeof ManufacturingWorkOrdersIndexRouteImport;
      parentRoute: typeof ManufacturingRoute;
    };
    '/manufacturing/work-orders/$workOrderId': {
      id: '/manufacturing/work-orders/$workOrderId';
      path: '/work-orders/$workOrderId';
      fullPath: '/manufacturing/work-orders/$workOrderId';
      preLoaderRoute: typeof ManufacturingWorkOrdersWorkOrderIdRouteImport;
      parentRoute: typeof ManufacturingRoute;
    };
    '/parts/new/': {
      id: '/parts/new/';
      path: '/';
      fullPath: '/parts/new/';
      preLoaderRoute: typeof PartsNewIndexRouteImport;
      parentRoute: typeof PartsNewRouteRoute;
    };
    '/receiving/returns/$salesOrderId': {
      id: '/receiving/returns/$salesOrderId';
      path: '/returns/$salesOrderId';
      fullPath: '/receiving/returns/$salesOrderId';
      preLoaderRoute: typeof ReceivingReturnsSalesOrderIdRouteImport;
      parentRoute: typeof ReceivingRoute;
    };
    '/receiving/transfer/$transferOrderId': {
      id: '/receiving/transfer/$transferOrderId';
      path: '/transfer/$transferOrderId';
      fullPath: '/receiving/transfer/$transferOrderId';
      preLoaderRoute: typeof ReceivingTransferTransferOrderIdRouteImport;
      parentRoute: typeof ReceivingRoute;
    };
    '/warehouses/$locationGroupId/': {
      id: '/warehouses/$locationGroupId/';
      path: '/';
      fullPath: '/warehouses/$locationGroupId/';
      preLoaderRoute: typeof WarehousesLocationGroupIdIndexRouteImport;
      parentRoute: typeof WarehousesLocationGroupIdRouteRoute;
    };
    '/warehouses/$locationGroupId/$locationId': {
      id: '/warehouses/$locationGroupId/$locationId';
      path: '/$locationId';
      fullPath: '/warehouses/$locationGroupId/$locationId';
      preLoaderRoute: typeof WarehousesLocationGroupIdLocationIdRouteImport;
      parentRoute: typeof WarehousesLocationGroupIdRouteRoute;
    };
    '/warehouses/$locationGroupId/new': {
      id: '/warehouses/$locationGroupId/new';
      path: '/new';
      fullPath: '/warehouses/$locationGroupId/new';
      preLoaderRoute: typeof WarehousesLocationGroupIdNewRouteImport;
      parentRoute: typeof WarehousesLocationGroupIdRouteRoute;
    };
    '/integrations/leaflink/$leafLinkIntegrationId/': {
      id: '/integrations/leaflink/$leafLinkIntegrationId/';
      path: '/$leafLinkIntegrationId';
      fullPath: '/integrations/leaflink/$leafLinkIntegrationId/';
      preLoaderRoute: typeof IntegrationsLeaflinkLeafLinkIntegrationIdIndexRouteImport;
      parentRoute: typeof IntegrationsLeaflinkRouteRoute;
    };
    '/integrations/leaflink/$leafLinkIntegrationId/customers': {
      id: '/integrations/leaflink/$leafLinkIntegrationId/customers';
      path: '/$leafLinkIntegrationId/customers';
      fullPath: '/integrations/leaflink/$leafLinkIntegrationId/customers';
      preLoaderRoute: typeof IntegrationsLeaflinkLeafLinkIntegrationIdCustomersRouteImport;
      parentRoute: typeof IntegrationsLeaflinkRouteRoute;
    };
    '/integrations/leaflink/$leafLinkIntegrationId/held-orders': {
      id: '/integrations/leaflink/$leafLinkIntegrationId/held-orders';
      path: '/$leafLinkIntegrationId/held-orders';
      fullPath: '/integrations/leaflink/$leafLinkIntegrationId/held-orders';
      preLoaderRoute: typeof IntegrationsLeaflinkLeafLinkIntegrationIdHeldOrdersRouteImport;
      parentRoute: typeof IntegrationsLeaflinkRouteRoute;
    };
    '/integrations/leaflink/$leafLinkIntegrationId/list-products': {
      id: '/integrations/leaflink/$leafLinkIntegrationId/list-products';
      path: '/$leafLinkIntegrationId/list-products';
      fullPath: '/integrations/leaflink/$leafLinkIntegrationId/list-products';
      preLoaderRoute: typeof IntegrationsLeaflinkLeafLinkIntegrationIdListProductsRouteImport;
      parentRoute: typeof IntegrationsLeaflinkRouteRoute;
    };
    '/integrations/leaflink/$leafLinkIntegrationId/orders': {
      id: '/integrations/leaflink/$leafLinkIntegrationId/orders';
      path: '/$leafLinkIntegrationId/orders';
      fullPath: '/integrations/leaflink/$leafLinkIntegrationId/orders';
      preLoaderRoute: typeof IntegrationsLeaflinkLeafLinkIntegrationIdOrdersRouteImport;
      parentRoute: typeof IntegrationsLeaflinkRouteRoute;
    };
    '/integrations/leaflink/$leafLinkIntegrationId/products': {
      id: '/integrations/leaflink/$leafLinkIntegrationId/products';
      path: '/$leafLinkIntegrationId/products';
      fullPath: '/integrations/leaflink/$leafLinkIntegrationId/products';
      preLoaderRoute: typeof IntegrationsLeaflinkLeafLinkIntegrationIdProductsRouteImport;
      parentRoute: typeof IntegrationsLeaflinkRouteRoute;
    };
  }
}

interface AccountsReceivableRouteRouteChildren {
  AccountsReceivableIndexRoute: typeof AccountsReceivableIndexRoute;
}

const AccountsReceivableRouteRouteChildren: AccountsReceivableRouteRouteChildren =
  {
    AccountsReceivableIndexRoute: AccountsReceivableIndexRoute,
  };

const AccountsReceivableRouteRouteWithChildren =
  AccountsReceivableRouteRoute._addFileChildren(
    AccountsReceivableRouteRouteChildren,
  );

interface BomsRouteRouteChildren {
  BomsBomIdRoute: typeof BomsBomIdRoute;
  BomsNewRoute: typeof BomsNewRoute;
  BomsIndexRoute: typeof BomsIndexRoute;
}

const BomsRouteRouteChildren: BomsRouteRouteChildren = {
  BomsBomIdRoute: BomsBomIdRoute,
  BomsNewRoute: BomsNewRoute,
  BomsIndexRoute: BomsIndexRoute,
};

const BomsRouteRouteWithChildren = BomsRouteRoute._addFileChildren(
  BomsRouteRouteChildren,
);

interface BrandsRouteRouteChildren {
  BrandsBrandIdRoute: typeof BrandsBrandIdRoute;
  BrandsNewRoute: typeof BrandsNewRoute;
  BrandsIndexRoute: typeof BrandsIndexRoute;
}

const BrandsRouteRouteChildren: BrandsRouteRouteChildren = {
  BrandsBrandIdRoute: BrandsBrandIdRoute,
  BrandsNewRoute: BrandsNewRoute,
  BrandsIndexRoute: BrandsIndexRoute,
};

const BrandsRouteRouteWithChildren = BrandsRouteRoute._addFileChildren(
  BrandsRouteRouteChildren,
);

interface CompanySettingsRouteRouteChildren {
  CompanySettingsIndexRoute: typeof CompanySettingsIndexRoute;
}

const CompanySettingsRouteRouteChildren: CompanySettingsRouteRouteChildren = {
  CompanySettingsIndexRoute: CompanySettingsIndexRoute,
};

const CompanySettingsRouteRouteWithChildren =
  CompanySettingsRouteRoute._addFileChildren(CompanySettingsRouteRouteChildren);

interface CompanySetupRouteRouteChildren {
  CompanySetupIndexRoute: typeof CompanySetupIndexRoute;
}

const CompanySetupRouteRouteChildren: CompanySetupRouteRouteChildren = {
  CompanySetupIndexRoute: CompanySetupIndexRoute,
};

const CompanySetupRouteRouteWithChildren =
  CompanySetupRouteRoute._addFileChildren(CompanySetupRouteRouteChildren);

interface CreditsRouteRouteChildren {
  CreditsCreditIdRoute: typeof CreditsCreditIdRoute;
  CreditsIndexRoute: typeof CreditsIndexRoute;
}

const CreditsRouteRouteChildren: CreditsRouteRouteChildren = {
  CreditsCreditIdRoute: CreditsCreditIdRoute,
  CreditsIndexRoute: CreditsIndexRoute,
};

const CreditsRouteRouteWithChildren = CreditsRouteRoute._addFileChildren(
  CreditsRouteRouteChildren,
);

interface CustomersRouteRouteChildren {
  CustomersCustomerIdRoute: typeof CustomersCustomerIdRoute;
  CustomersNewRoute: typeof CustomersNewRoute;
  CustomersIndexRoute: typeof CustomersIndexRoute;
}

const CustomersRouteRouteChildren: CustomersRouteRouteChildren = {
  CustomersCustomerIdRoute: CustomersCustomerIdRoute,
  CustomersNewRoute: CustomersNewRoute,
  CustomersIndexRoute: CustomersIndexRoute,
};

const CustomersRouteRouteWithChildren = CustomersRouteRoute._addFileChildren(
  CustomersRouteRouteChildren,
);

interface DepartmentsRouteRouteChildren {
  DepartmentsDepartmentIdRoute: typeof DepartmentsDepartmentIdRoute;
  DepartmentsNewRoute: typeof DepartmentsNewRoute;
  DepartmentsIndexRoute: typeof DepartmentsIndexRoute;
}

const DepartmentsRouteRouteChildren: DepartmentsRouteRouteChildren = {
  DepartmentsDepartmentIdRoute: DepartmentsDepartmentIdRoute,
  DepartmentsNewRoute: DepartmentsNewRoute,
  DepartmentsIndexRoute: DepartmentsIndexRoute,
};

const DepartmentsRouteRouteWithChildren =
  DepartmentsRouteRoute._addFileChildren(DepartmentsRouteRouteChildren);

interface DesignSystemRouteRouteChildren {
  DesignSystemAccordionRoute: typeof DesignSystemAccordionRoute;
  DesignSystemAlertRoute: typeof DesignSystemAlertRoute;
  DesignSystemAspectRatioRoute: typeof DesignSystemAspectRatioRoute;
  DesignSystemAttachmentRoute: typeof DesignSystemAttachmentRoute;
  DesignSystemAvatarRoute: typeof DesignSystemAvatarRoute;
  DesignSystemBreadcrumbRoute: typeof DesignSystemBreadcrumbRoute;
  DesignSystemButtonRoute: typeof DesignSystemButtonRoute;
  DesignSystemButtonGroupRoute: typeof DesignSystemButtonGroupRoute;
  DesignSystemCalendarRoute: typeof DesignSystemCalendarRoute;
  DesignSystemCardRoute: typeof DesignSystemCardRoute;
  DesignSystemCardShellRoute: typeof DesignSystemCardShellRoute;
  DesignSystemCheckboxRoute: typeof DesignSystemCheckboxRoute;
  DesignSystemChipRoute: typeof DesignSystemChipRoute;
  DesignSystemCollapsibleRoute: typeof DesignSystemCollapsibleRoute;
  DesignSystemComboboxRoute: typeof DesignSystemComboboxRoute;
  DesignSystemDataTableRoute: typeof DesignSystemDataTableRoute;
  DesignSystemDatePickerRoute: typeof DesignSystemDatePickerRoute;
  DesignSystemDetailCardShellRoute: typeof DesignSystemDetailCardShellRoute;
  DesignSystemDetailPageStatesRoute: typeof DesignSystemDetailPageStatesRoute;
  DesignSystemDialogRoute: typeof DesignSystemDialogRoute;
  DesignSystemDropdownMenuRoute: typeof DesignSystemDropdownMenuRoute;
  DesignSystemEditableCellRoute: typeof DesignSystemEditableCellRoute;
  DesignSystemEmptyRoute: typeof DesignSystemEmptyRoute;
  DesignSystemFieldRoute: typeof DesignSystemFieldRoute;
  DesignSystemFilterButtonRoute: typeof DesignSystemFilterButtonRoute;
  DesignSystemInputRoute: typeof DesignSystemInputRoute;
  DesignSystemInputGroupRoute: typeof DesignSystemInputGroupRoute;
  DesignSystemItemRoute: typeof DesignSystemItemRoute;
  DesignSystemLabelRoute: typeof DesignSystemLabelRoute;
  DesignSystemMenubarRoute: typeof DesignSystemMenubarRoute;
  DesignSystemNestedTableRoute: typeof DesignSystemNestedTableRoute;
  DesignSystemRadioGroupRoute: typeof DesignSystemRadioGroupRoute;
  DesignSystemResizableRoute: typeof DesignSystemResizableRoute;
  DesignSystemScrollAreaRoute: typeof DesignSystemScrollAreaRoute;
  DesignSystemSelectRoute: typeof DesignSystemSelectRoute;
  DesignSystemSeparatorRoute: typeof DesignSystemSeparatorRoute;
  DesignSystemSheetRoute: typeof DesignSystemSheetRoute;
  DesignSystemSidebarRoute: typeof DesignSystemSidebarRoute;
  DesignSystemSonnerRoute: typeof DesignSystemSonnerRoute;
  DesignSystemSpinnerRoute: typeof DesignSystemSpinnerRoute;
  DesignSystemSwitchRoute: typeof DesignSystemSwitchRoute;
  DesignSystemTableRoute: typeof DesignSystemTableRoute;
  DesignSystemTabsRoute: typeof DesignSystemTabsRoute;
  DesignSystemTextareaRoute: typeof DesignSystemTextareaRoute;
  DesignSystemToggleRoute: typeof DesignSystemToggleRoute;
  DesignSystemToggleGroupRoute: typeof DesignSystemToggleGroupRoute;
  DesignSystemTooltipRoute: typeof DesignSystemTooltipRoute;
  DesignSystemTreeComboboxRoute: typeof DesignSystemTreeComboboxRoute;
  DesignSystemTreeTableRoute: typeof DesignSystemTreeTableRoute;
  DesignSystemWizardRoute: typeof DesignSystemWizardRoute;
  DesignSystemIndexRoute: typeof DesignSystemIndexRoute;
}

const DesignSystemRouteRouteChildren: DesignSystemRouteRouteChildren = {
  DesignSystemAccordionRoute: DesignSystemAccordionRoute,
  DesignSystemAlertRoute: DesignSystemAlertRoute,
  DesignSystemAspectRatioRoute: DesignSystemAspectRatioRoute,
  DesignSystemAttachmentRoute: DesignSystemAttachmentRoute,
  DesignSystemAvatarRoute: DesignSystemAvatarRoute,
  DesignSystemBreadcrumbRoute: DesignSystemBreadcrumbRoute,
  DesignSystemButtonRoute: DesignSystemButtonRoute,
  DesignSystemButtonGroupRoute: DesignSystemButtonGroupRoute,
  DesignSystemCalendarRoute: DesignSystemCalendarRoute,
  DesignSystemCardRoute: DesignSystemCardRoute,
  DesignSystemCardShellRoute: DesignSystemCardShellRoute,
  DesignSystemCheckboxRoute: DesignSystemCheckboxRoute,
  DesignSystemChipRoute: DesignSystemChipRoute,
  DesignSystemCollapsibleRoute: DesignSystemCollapsibleRoute,
  DesignSystemComboboxRoute: DesignSystemComboboxRoute,
  DesignSystemDataTableRoute: DesignSystemDataTableRoute,
  DesignSystemDatePickerRoute: DesignSystemDatePickerRoute,
  DesignSystemDetailCardShellRoute: DesignSystemDetailCardShellRoute,
  DesignSystemDetailPageStatesRoute: DesignSystemDetailPageStatesRoute,
  DesignSystemDialogRoute: DesignSystemDialogRoute,
  DesignSystemDropdownMenuRoute: DesignSystemDropdownMenuRoute,
  DesignSystemEditableCellRoute: DesignSystemEditableCellRoute,
  DesignSystemEmptyRoute: DesignSystemEmptyRoute,
  DesignSystemFieldRoute: DesignSystemFieldRoute,
  DesignSystemFilterButtonRoute: DesignSystemFilterButtonRoute,
  DesignSystemInputRoute: DesignSystemInputRoute,
  DesignSystemInputGroupRoute: DesignSystemInputGroupRoute,
  DesignSystemItemRoute: DesignSystemItemRoute,
  DesignSystemLabelRoute: DesignSystemLabelRoute,
  DesignSystemMenubarRoute: DesignSystemMenubarRoute,
  DesignSystemNestedTableRoute: DesignSystemNestedTableRoute,
  DesignSystemRadioGroupRoute: DesignSystemRadioGroupRoute,
  DesignSystemResizableRoute: DesignSystemResizableRoute,
  DesignSystemScrollAreaRoute: DesignSystemScrollAreaRoute,
  DesignSystemSelectRoute: DesignSystemSelectRoute,
  DesignSystemSeparatorRoute: DesignSystemSeparatorRoute,
  DesignSystemSheetRoute: DesignSystemSheetRoute,
  DesignSystemSidebarRoute: DesignSystemSidebarRoute,
  DesignSystemSonnerRoute: DesignSystemSonnerRoute,
  DesignSystemSpinnerRoute: DesignSystemSpinnerRoute,
  DesignSystemSwitchRoute: DesignSystemSwitchRoute,
  DesignSystemTableRoute: DesignSystemTableRoute,
  DesignSystemTabsRoute: DesignSystemTabsRoute,
  DesignSystemTextareaRoute: DesignSystemTextareaRoute,
  DesignSystemToggleRoute: DesignSystemToggleRoute,
  DesignSystemToggleGroupRoute: DesignSystemToggleGroupRoute,
  DesignSystemTooltipRoute: DesignSystemTooltipRoute,
  DesignSystemTreeComboboxRoute: DesignSystemTreeComboboxRoute,
  DesignSystemTreeTableRoute: DesignSystemTreeTableRoute,
  DesignSystemWizardRoute: DesignSystemWizardRoute,
  DesignSystemIndexRoute: DesignSystemIndexRoute,
};

const DesignSystemRouteRouteWithChildren =
  DesignSystemRouteRoute._addFileChildren(DesignSystemRouteRouteChildren);

interface InventoryRouteRouteChildren {
  InventoryLotHistoryRoute: typeof InventoryLotHistoryRoute;
  InventoryTagsRoute: typeof InventoryTagsRoute;
  InventoryIndexRoute: typeof InventoryIndexRoute;
  InventoryCountsNewRoute: typeof InventoryCountsNewRoute;
}

const InventoryRouteRouteChildren: InventoryRouteRouteChildren = {
  InventoryLotHistoryRoute: InventoryLotHistoryRoute,
  InventoryTagsRoute: InventoryTagsRoute,
  InventoryIndexRoute: InventoryIndexRoute,
  InventoryCountsNewRoute: InventoryCountsNewRoute,
};

const InventoryRouteRouteWithChildren = InventoryRouteRoute._addFileChildren(
  InventoryRouteRouteChildren,
);

interface InvoicesRouteRouteChildren {
  InvoicesInvoiceIdRoute: typeof InvoicesInvoiceIdRoute;
  InvoicesIndexRoute: typeof InvoicesIndexRoute;
}

const InvoicesRouteRouteChildren: InvoicesRouteRouteChildren = {
  InvoicesInvoiceIdRoute: InvoicesInvoiceIdRoute,
  InvoicesIndexRoute: InvoicesIndexRoute,
};

const InvoicesRouteRouteWithChildren = InvoicesRouteRoute._addFileChildren(
  InvoicesRouteRouteChildren,
);

interface LocationGroupsRouteRouteChildren {
  LocationGroupsLocationGroupIdRoute: typeof LocationGroupsLocationGroupIdRoute;
  LocationGroupsNewRoute: typeof LocationGroupsNewRoute;
  LocationGroupsIndexRoute: typeof LocationGroupsIndexRoute;
}

const LocationGroupsRouteRouteChildren: LocationGroupsRouteRouteChildren = {
  LocationGroupsLocationGroupIdRoute: LocationGroupsLocationGroupIdRoute,
  LocationGroupsNewRoute: LocationGroupsNewRoute,
  LocationGroupsIndexRoute: LocationGroupsIndexRoute,
};

const LocationGroupsRouteRouteWithChildren =
  LocationGroupsRouteRoute._addFileChildren(LocationGroupsRouteRouteChildren);

interface LocationsRouteRouteChildren {
  LocationsLocationIdRoute: typeof LocationsLocationIdRoute;
  LocationsNewRoute: typeof LocationsNewRoute;
  LocationsIndexRoute: typeof LocationsIndexRoute;
}

const LocationsRouteRouteChildren: LocationsRouteRouteChildren = {
  LocationsLocationIdRoute: LocationsLocationIdRoute,
  LocationsNewRoute: LocationsNewRoute,
  LocationsIndexRoute: LocationsIndexRoute,
};

const LocationsRouteRouteWithChildren = LocationsRouteRoute._addFileChildren(
  LocationsRouteRouteChildren,
);

interface PartsNewRouteRouteChildren {
  PartsNewIndexRoute: typeof PartsNewIndexRoute;
}

const PartsNewRouteRouteChildren: PartsNewRouteRouteChildren = {
  PartsNewIndexRoute: PartsNewIndexRoute,
};

const PartsNewRouteRouteWithChildren = PartsNewRouteRoute._addFileChildren(
  PartsNewRouteRouteChildren,
);

interface PartsRouteRouteChildren {
  PartsNewRouteRoute: typeof PartsNewRouteRouteWithChildren;
  PartsPartIdRoute: typeof PartsPartIdRoute;
  PartsIndexRoute: typeof PartsIndexRoute;
}

const PartsRouteRouteChildren: PartsRouteRouteChildren = {
  PartsNewRouteRoute: PartsNewRouteRouteWithChildren,
  PartsPartIdRoute: PartsPartIdRoute,
  PartsIndexRoute: PartsIndexRoute,
};

const PartsRouteRouteWithChildren = PartsRouteRoute._addFileChildren(
  PartsRouteRouteChildren,
);

interface PickingRouteRouteChildren {
  PickingIndexRoute: typeof PickingIndexRoute;
}

const PickingRouteRouteChildren: PickingRouteRouteChildren = {
  PickingIndexRoute: PickingIndexRoute,
};

const PickingRouteRouteWithChildren = PickingRouteRoute._addFileChildren(
  PickingRouteRouteChildren,
);

interface PricingRouteRouteChildren {
  PricingIndexRoute: typeof PricingIndexRoute;
}

const PricingRouteRouteChildren: PricingRouteRouteChildren = {
  PricingIndexRoute: PricingIndexRoute,
};

const PricingRouteRouteWithChildren = PricingRouteRoute._addFileChildren(
  PricingRouteRouteChildren,
);

interface PricingRulesRouteRouteChildren {
  PricingRulesPriceRuleIdRoute: typeof PricingRulesPriceRuleIdRoute;
  PricingRulesIndexRoute: typeof PricingRulesIndexRoute;
}

const PricingRulesRouteRouteChildren: PricingRulesRouteRouteChildren = {
  PricingRulesPriceRuleIdRoute: PricingRulesPriceRuleIdRoute,
  PricingRulesIndexRoute: PricingRulesIndexRoute,
};

const PricingRulesRouteRouteWithChildren =
  PricingRulesRouteRoute._addFileChildren(PricingRulesRouteRouteChildren);

interface ProductCategoriesRouteRouteChildren {
  ProductCategoriesProductTreeIdRoute: typeof ProductCategoriesProductTreeIdRoute;
  ProductCategoriesIndexRoute: typeof ProductCategoriesIndexRoute;
}

const ProductCategoriesRouteRouteChildren: ProductCategoriesRouteRouteChildren =
  {
    ProductCategoriesProductTreeIdRoute: ProductCategoriesProductTreeIdRoute,
    ProductCategoriesIndexRoute: ProductCategoriesIndexRoute,
  };

const ProductCategoriesRouteRouteWithChildren =
  ProductCategoriesRouteRoute._addFileChildren(
    ProductCategoriesRouteRouteChildren,
  );

interface ProductsRouteRouteChildren {
  ProductsProductIdRoute: typeof ProductsProductIdRoute;
  ProductsNewRoute: typeof ProductsNewRoute;
  ProductsIndexRoute: typeof ProductsIndexRoute;
}

const ProductsRouteRouteChildren: ProductsRouteRouteChildren = {
  ProductsProductIdRoute: ProductsProductIdRoute,
  ProductsNewRoute: ProductsNewRoute,
  ProductsIndexRoute: ProductsIndexRoute,
};

const ProductsRouteRouteWithChildren = ProductsRouteRoute._addFileChildren(
  ProductsRouteRouteChildren,
);

interface RolesRouteRouteChildren {
  RolesRoleIdRoute: typeof RolesRoleIdRoute;
  RolesNewRoute: typeof RolesNewRoute;
  RolesIndexRoute: typeof RolesIndexRoute;
}

const RolesRouteRouteChildren: RolesRouteRouteChildren = {
  RolesRoleIdRoute: RolesRoleIdRoute,
  RolesNewRoute: RolesNewRoute,
  RolesIndexRoute: RolesIndexRoute,
};

const RolesRouteRouteWithChildren = RolesRouteRoute._addFileChildren(
  RolesRouteRouteChildren,
);

interface SalesOrdersRouteRouteChildren {
  SalesOrdersSalesOrderIdRoute: typeof SalesOrdersSalesOrderIdRoute;
  SalesOrdersNewRoute: typeof SalesOrdersNewRoute;
  SalesOrdersIndexRoute: typeof SalesOrdersIndexRoute;
}

const SalesOrdersRouteRouteChildren: SalesOrdersRouteRouteChildren = {
  SalesOrdersSalesOrderIdRoute: SalesOrdersSalesOrderIdRoute,
  SalesOrdersNewRoute: SalesOrdersNewRoute,
  SalesOrdersIndexRoute: SalesOrdersIndexRoute,
};

const SalesOrdersRouteRouteWithChildren =
  SalesOrdersRouteRoute._addFileChildren(SalesOrdersRouteRouteChildren);

interface TransferOrdersRouteRouteChildren {
  TransferOrdersTransferOrderIdRoute: typeof TransferOrdersTransferOrderIdRoute;
  TransferOrdersNewRoute: typeof TransferOrdersNewRoute;
  TransferOrdersIndexRoute: typeof TransferOrdersIndexRoute;
}

const TransferOrdersRouteRouteChildren: TransferOrdersRouteRouteChildren = {
  TransferOrdersTransferOrderIdRoute: TransferOrdersTransferOrderIdRoute,
  TransferOrdersNewRoute: TransferOrdersNewRoute,
  TransferOrdersIndexRoute: TransferOrdersIndexRoute,
};

const TransferOrdersRouteRouteWithChildren =
  TransferOrdersRouteRoute._addFileChildren(TransferOrdersRouteRouteChildren);

interface UsersRouteRouteChildren {
  UsersUserIdRoute: typeof UsersUserIdRoute;
  UsersIndexRoute: typeof UsersIndexRoute;
}

const UsersRouteRouteChildren: UsersRouteRouteChildren = {
  UsersUserIdRoute: UsersUserIdRoute,
  UsersIndexRoute: UsersIndexRoute,
};

const UsersRouteRouteWithChildren = UsersRouteRoute._addFileChildren(
  UsersRouteRouteChildren,
);

interface VendorsRouteRouteChildren {
  VendorsVendorIdRoute: typeof VendorsVendorIdRoute;
  VendorsNewRoute: typeof VendorsNewRoute;
  VendorsIndexRoute: typeof VendorsIndexRoute;
}

const VendorsRouteRouteChildren: VendorsRouteRouteChildren = {
  VendorsVendorIdRoute: VendorsVendorIdRoute,
  VendorsNewRoute: VendorsNewRoute,
  VendorsIndexRoute: VendorsIndexRoute,
};

const VendorsRouteRouteWithChildren = VendorsRouteRoute._addFileChildren(
  VendorsRouteRouteChildren,
);

interface WarehousesLocationGroupIdRouteRouteChildren {
  WarehousesLocationGroupIdLocationIdRoute: typeof WarehousesLocationGroupIdLocationIdRoute;
  WarehousesLocationGroupIdNewRoute: typeof WarehousesLocationGroupIdNewRoute;
  WarehousesLocationGroupIdIndexRoute: typeof WarehousesLocationGroupIdIndexRoute;
}

const WarehousesLocationGroupIdRouteRouteChildren: WarehousesLocationGroupIdRouteRouteChildren =
  {
    WarehousesLocationGroupIdLocationIdRoute:
      WarehousesLocationGroupIdLocationIdRoute,
    WarehousesLocationGroupIdNewRoute: WarehousesLocationGroupIdNewRoute,
    WarehousesLocationGroupIdIndexRoute: WarehousesLocationGroupIdIndexRoute,
  };

const WarehousesLocationGroupIdRouteRouteWithChildren =
  WarehousesLocationGroupIdRouteRoute._addFileChildren(
    WarehousesLocationGroupIdRouteRouteChildren,
  );

interface WarehousesRouteRouteChildren {
  WarehousesLocationGroupIdRouteRoute: typeof WarehousesLocationGroupIdRouteRouteWithChildren;
  WarehousesNewRoute: typeof WarehousesNewRoute;
  WarehousesIndexRoute: typeof WarehousesIndexRoute;
}

const WarehousesRouteRouteChildren: WarehousesRouteRouteChildren = {
  WarehousesLocationGroupIdRouteRoute:
    WarehousesLocationGroupIdRouteRouteWithChildren,
  WarehousesNewRoute: WarehousesNewRoute,
  WarehousesIndexRoute: WarehousesIndexRoute,
};

const WarehousesRouteRouteWithChildren = WarehousesRouteRoute._addFileChildren(
  WarehousesRouteRouteChildren,
);

interface AuditTrailRouteChildren {
  AuditTrailIndexRoute: typeof AuditTrailIndexRoute;
}

const AuditTrailRouteChildren: AuditTrailRouteChildren = {
  AuditTrailIndexRoute: AuditTrailIndexRoute,
};

const AuditTrailRouteWithChildren = AuditTrailRoute._addFileChildren(
  AuditTrailRouteChildren,
);

interface ManufacturingRouteChildren {
  ManufacturingManufacturingOrderIdRoute: typeof ManufacturingManufacturingOrderIdRoute;
  ManufacturingNewRoute: typeof ManufacturingNewRoute;
  ManufacturingIndexRoute: typeof ManufacturingIndexRoute;
  ManufacturingWorkOrdersWorkOrderIdRoute: typeof ManufacturingWorkOrdersWorkOrderIdRoute;
  ManufacturingWorkOrdersIndexRoute: typeof ManufacturingWorkOrdersIndexRoute;
}

const ManufacturingRouteChildren: ManufacturingRouteChildren = {
  ManufacturingManufacturingOrderIdRoute:
    ManufacturingManufacturingOrderIdRoute,
  ManufacturingNewRoute: ManufacturingNewRoute,
  ManufacturingIndexRoute: ManufacturingIndexRoute,
  ManufacturingWorkOrdersWorkOrderIdRoute:
    ManufacturingWorkOrdersWorkOrderIdRoute,
  ManufacturingWorkOrdersIndexRoute: ManufacturingWorkOrdersIndexRoute,
};

const ManufacturingRouteWithChildren = ManufacturingRoute._addFileChildren(
  ManufacturingRouteChildren,
);

interface PurchaseOrdersRouteChildren {
  PurchaseOrdersPurchaseOrderIdRoute: typeof PurchaseOrdersPurchaseOrderIdRoute;
  PurchaseOrdersNewRoute: typeof PurchaseOrdersNewRoute;
  PurchaseOrdersIndexRoute: typeof PurchaseOrdersIndexRoute;
}

const PurchaseOrdersRouteChildren: PurchaseOrdersRouteChildren = {
  PurchaseOrdersPurchaseOrderIdRoute: PurchaseOrdersPurchaseOrderIdRoute,
  PurchaseOrdersNewRoute: PurchaseOrdersNewRoute,
  PurchaseOrdersIndexRoute: PurchaseOrdersIndexRoute,
};

const PurchaseOrdersRouteWithChildren = PurchaseOrdersRoute._addFileChildren(
  PurchaseOrdersRouteChildren,
);

interface ReceivingRouteChildren {
  ReceivingPurchaseOrderIdRoute: typeof ReceivingPurchaseOrderIdRoute;
  ReceivingIndexRoute: typeof ReceivingIndexRoute;
  ReceivingReturnsSalesOrderIdRoute: typeof ReceivingReturnsSalesOrderIdRoute;
  ReceivingTransferTransferOrderIdRoute: typeof ReceivingTransferTransferOrderIdRoute;
}

const ReceivingRouteChildren: ReceivingRouteChildren = {
  ReceivingPurchaseOrderIdRoute: ReceivingPurchaseOrderIdRoute,
  ReceivingIndexRoute: ReceivingIndexRoute,
  ReceivingReturnsSalesOrderIdRoute: ReceivingReturnsSalesOrderIdRoute,
  ReceivingTransferTransferOrderIdRoute: ReceivingTransferTransferOrderIdRoute,
};

const ReceivingRouteWithChildren = ReceivingRoute._addFileChildren(
  ReceivingRouteChildren,
);

interface SupplierReturnsRouteChildren {
  SupplierReturnsIndexRoute: typeof SupplierReturnsIndexRoute;
}

const SupplierReturnsRouteChildren: SupplierReturnsRouteChildren = {
  SupplierReturnsIndexRoute: SupplierReturnsIndexRoute,
};

const SupplierReturnsRouteWithChildren = SupplierReturnsRoute._addFileChildren(
  SupplierReturnsRouteChildren,
);

interface IntegrationsLeaflinkRouteRouteChildren {
  IntegrationsLeaflinkIndexRoute: typeof IntegrationsLeaflinkIndexRoute;
  IntegrationsLeaflinkLeafLinkIntegrationIdCustomersRoute: typeof IntegrationsLeaflinkLeafLinkIntegrationIdCustomersRoute;
  IntegrationsLeaflinkLeafLinkIntegrationIdHeldOrdersRoute: typeof IntegrationsLeaflinkLeafLinkIntegrationIdHeldOrdersRoute;
  IntegrationsLeaflinkLeafLinkIntegrationIdListProductsRoute: typeof IntegrationsLeaflinkLeafLinkIntegrationIdListProductsRoute;
  IntegrationsLeaflinkLeafLinkIntegrationIdOrdersRoute: typeof IntegrationsLeaflinkLeafLinkIntegrationIdOrdersRoute;
  IntegrationsLeaflinkLeafLinkIntegrationIdProductsRoute: typeof IntegrationsLeaflinkLeafLinkIntegrationIdProductsRoute;
  IntegrationsLeaflinkLeafLinkIntegrationIdIndexRoute: typeof IntegrationsLeaflinkLeafLinkIntegrationIdIndexRoute;
}

const IntegrationsLeaflinkRouteRouteChildren: IntegrationsLeaflinkRouteRouteChildren =
  {
    IntegrationsLeaflinkIndexRoute: IntegrationsLeaflinkIndexRoute,
    IntegrationsLeaflinkLeafLinkIntegrationIdCustomersRoute:
      IntegrationsLeaflinkLeafLinkIntegrationIdCustomersRoute,
    IntegrationsLeaflinkLeafLinkIntegrationIdHeldOrdersRoute:
      IntegrationsLeaflinkLeafLinkIntegrationIdHeldOrdersRoute,
    IntegrationsLeaflinkLeafLinkIntegrationIdListProductsRoute:
      IntegrationsLeaflinkLeafLinkIntegrationIdListProductsRoute,
    IntegrationsLeaflinkLeafLinkIntegrationIdOrdersRoute:
      IntegrationsLeaflinkLeafLinkIntegrationIdOrdersRoute,
    IntegrationsLeaflinkLeafLinkIntegrationIdProductsRoute:
      IntegrationsLeaflinkLeafLinkIntegrationIdProductsRoute,
    IntegrationsLeaflinkLeafLinkIntegrationIdIndexRoute:
      IntegrationsLeaflinkLeafLinkIntegrationIdIndexRoute,
  };

const IntegrationsLeaflinkRouteRouteWithChildren =
  IntegrationsLeaflinkRouteRoute._addFileChildren(
    IntegrationsLeaflinkRouteRouteChildren,
  );

interface IntegrationsSageIntacctRouteRouteChildren {
  IntegrationsSageIntacctIndexRoute: typeof IntegrationsSageIntacctIndexRoute;
}

const IntegrationsSageIntacctRouteRouteChildren: IntegrationsSageIntacctRouteRouteChildren =
  {
    IntegrationsSageIntacctIndexRoute: IntegrationsSageIntacctIndexRoute,
  };

const IntegrationsSageIntacctRouteRouteWithChildren =
  IntegrationsSageIntacctRouteRoute._addFileChildren(
    IntegrationsSageIntacctRouteRouteChildren,
  );

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountsReceivableRouteRoute: AccountsReceivableRouteRouteWithChildren,
  BomsRouteRoute: BomsRouteRouteWithChildren,
  BrandsRouteRoute: BrandsRouteRouteWithChildren,
  CompanySettingsRouteRoute: CompanySettingsRouteRouteWithChildren,
  CompanySetupRouteRoute: CompanySetupRouteRouteWithChildren,
  CreditsRouteRoute: CreditsRouteRouteWithChildren,
  CustomersRouteRoute: CustomersRouteRouteWithChildren,
  DepartmentsRouteRoute: DepartmentsRouteRouteWithChildren,
  DesignSystemRouteRoute: DesignSystemRouteRouteWithChildren,
  InventoryRouteRoute: InventoryRouteRouteWithChildren,
  InvoicesRouteRoute: InvoicesRouteRouteWithChildren,
  LocationGroupsRouteRoute: LocationGroupsRouteRouteWithChildren,
  LocationsRouteRoute: LocationsRouteRouteWithChildren,
  PartsRouteRoute: PartsRouteRouteWithChildren,
  PickingRouteRoute: PickingRouteRouteWithChildren,
  PricingRouteRoute: PricingRouteRouteWithChildren,
  PricingRulesRouteRoute: PricingRulesRouteRouteWithChildren,
  ProductCategoriesRouteRoute: ProductCategoriesRouteRouteWithChildren,
  ProductsRouteRoute: ProductsRouteRouteWithChildren,
  RolesRouteRoute: RolesRouteRouteWithChildren,
  SalesOrdersRouteRoute: SalesOrdersRouteRouteWithChildren,
  TransferOrdersRouteRoute: TransferOrdersRouteRouteWithChildren,
  UsersRouteRoute: UsersRouteRouteWithChildren,
  VendorsRouteRoute: VendorsRouteRouteWithChildren,
  WarehousesRouteRoute: WarehousesRouteRouteWithChildren,
  AuditTrailRoute: AuditTrailRouteWithChildren,
  LoginRoute: LoginRoute,
  ManufacturingRoute: ManufacturingRouteWithChildren,
  PurchaseOrdersRoute: PurchaseOrdersRouteWithChildren,
  ReceivingRoute: ReceivingRouteWithChildren,
  SupplierReturnsRoute: SupplierReturnsRouteWithChildren,
  IntegrationsLeaflinkRouteRoute: IntegrationsLeaflinkRouteRouteWithChildren,
  IntegrationsSageIntacctRouteRoute:
    IntegrationsSageIntacctRouteRouteWithChildren,
  EventsEventIdRoute: EventsEventIdRoute,
  EventsAwaitingApprovalRoute: EventsAwaitingApprovalRoute,
  EventsAwaitingReviewRoute: EventsAwaitingReviewRoute,
  EventsContactsRoute: EventsContactsRoute,
  EventsNewRoute: EventsNewRoute,
  EventsTagsRoute: EventsTagsRoute,
  LeaflinkCompaniesSplatRoute: LeaflinkCompaniesSplatRoute,
  OauthConsentRoute: OauthConsentRoute,
  CustomReportsIndexRoute: CustomReportsIndexRoute,
  EventsIndexRoute: EventsIndexRoute,
  EventsTemplatesTemplateVersionIdRoute: EventsTemplatesTemplateVersionIdRoute,
  EventsTemplatesNewRoute: EventsTemplatesNewRoute,
  EventsTemplatesIndexRoute: EventsTemplatesIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
